import type { ResourceLanguage } from "i18next";

const en: ResourceLanguage = {
  "test": "This is a test.",
  "test_var": "This is a test with '{{var}}', a variable.",
  "tab_graphic": "View",
  "tab_content": "Content",
  "tab_meta_data": "Meta data",
  "tab_text": "Text list",
  "tab_scripts": "Interactions",
  "tab_invites": "Invites",
  "tab_compare": "Compare",
  "tab_attachments": "Attachments ({{count}})",
  "tab_admin": "Admin",
  "tab_admin_stats": "Stats",
  "tab_admin_updater": "Updater",
  "tab_admin_events": "Events",
  "tab_admin_tags": "Tags",
  "tab_admin_user": "Users",
  "tab_admin_graphics": "Graphics",
  "tab_admin_legacy": "Old admin pages",
  "tab_admin_icons": "Icon list",
  "tab_create_graphic": "New graphic",
  "tab_create_collection": "New Collection",
  "label_events_no_matches": "No matching events",
  "header_events_timestamp": "Time",
  "header_events_acting_user": "Acting user",
  "header_events_type": "Type",
  "header_events_entity": "Object",
  "header_events_action": "Action",
  "header_events_changes": "Changes to the entity",
  "header_events_attributes": "Attributes of the action",
  "header_events_comment": "Comment",
  "header_events_details": "Details",
  "header_events_cloned_graphic": "Cloned graphic",
  "header_events_cloning_user": "Cloning user",
  "header_events_language": "Language",
  "label_events_type_account": "User",
  "label_events_type_graphic": "Graphic",
  "label_events_type_invite": "Invite",
  "label_events_action_verb": "was ",
  "label_events_action_clone": "cloned",
  "label_events_action_create": "created",
  "label_events_action_replace": "saved",
  "label_events_action_auto_update": "auto-updated",
  "label_events_action_change_attribute": "changed",
  "label_events_action_delete": "deleted",
  "label_events_action_hide": "hidden",
  "label_events_action_publish": "published",
  "label_events_action_reactivate": "re-activated",
  "label_events_action_create_template": "downloaded as template",
  "label_events_action_send_mail": "notified by mail",
  "label_events_action_download": "downloaded",
  "label_events_action_commission": "commissioned",
  "label_events_action_view": "viewed",
  "label_events_action_modify": "modified",
  "label_events_action_tag": "(un-)tagged",
  "label_events_action_reserve_id": "saved incompletely (!)",
  "label_events_by": "by ",
  "label_events_ago": "ago",
  "label_events_invitation_role": "Role",
  "label_events_changes": "Changes",
  "label_events_changes_one": "{{count}} change",
  "label_events_changes_other": "{{count}} changes",
  "label_events_referrer_designerApp": "in Designer-App",
  "label_events_referrer_commissionGraphic": "in Designer-App (com.)",
  "label_events_referrer_save": "by graphic upload",
  "label_events_referrer_saveZip": "by archive upload",
  "label_events_referrer_uploadScript": "in Interactions-App",
  "label_events_referrer_svgRepo": "in Share",
  "label_events_referrer_clone": "by cloning",
  "label_events_referrer_rewriteInformal": "by automatic text transformation",
  "label_events_referrer_addTipLicense": ", adding licence information",
  "label_events_referrer": "",
  "header_events_change_attribute": "Attribute",
  "header_events_change_old": "Old",
  "header_events_change_new": "New",
  "header_events_change_key": "Key",
  "header_events_change_value": "Value",
  "label_events_attributes": "attributes",
  "label_events_attributes_one": "{{count}} attribute",
  "label_events_attributes_other": "{{count}} attributes",
  "label_events_clone_from_original": "from original",
  "header_events_added_tags": "Added tags",
  "header_events_removed_tags": "Removed tags",
  "toolbar_tools_title": "Tools:",
  "toolbar_scripts_title": "Interactions:",
  "toolbar_listen_title": "Play: ",
  "toolbar_select_title": "Selection mode: ",
  "label_changed": "changed",
  "label_changed_explain": "Actions are not available, because the graphic was changed. Please save first.",
  "label_not_changed": "not changed",
  "button_upload_dialog": "Upload",
  "button_files_dialog": "File manager",
  "button_download_dropdown": "Download",
  "button_save_graphic": "Save",
  "button_save_graphic_anyway": "Save anyway",
  "label_save_graphic_anyway": "Do you want to save the graphic anyway? Changes from the current revision will be overwritten and lost.",
  "label_cannot_edit": "You cannot edit this graphic. Reason: {{noEditReason}}",
  "label_may_login": "You may <a href=\"/login/auth\" target=\"_blank\">login in another tab</a>.",
  "heading_document_title": "Document title: ",
  "heading_document_description": "Document description: ",
  "heading_filter_text": "Filter by text",
  "label_filter_results": "{{count}} matches",
  "heading_active_areas": "Active areas",
  "header_id": "ID",
  "header_title": "Title",
  "header_description": "Description",
  "button_select_edit": "Select / edit",
  "button_select": "Select",
  "button_listen": "Play",
  "button_title": "Title",
  "button_description": "Description",
  "button_title_description": "Title and Description",
  "button_colormap": "Hit map",
  "label_print_mode": "Print method",
  "placeholder_print_mode": "Please select a print method",
  "button_emboss": "Emboss preview",
  "label_emboss_printer_selection": "Braille printer",
  "label_paper_size_selection": "Paper format",
  "label_document_size": "Document size",
  "paper_format_custom": "custom paper format",
  "paper_format_unknown": "unknown paper format",
  "paper_format_a2": "A2",
  "paper_format_a3": "A3",
  "paper_format_a4": "A4",
  "paper_format_a5": "A5",
  "paper_format_letter": "Letter",
  "paper_format_legal": "Legal",
  "paper_format_tabloid": "Tabloid / Ledger",
  "paper_format_tactonom": "Tactonom Pro Display",
  "paper_format_braillepaperlarge": "11 × 11½ inch",
  "paper_format_indexbrailletractor": "280mm × 12 inch",
  "paper_orientation_portrait": "portrait",
  "paper_orientation_landscape": "landscape",
  "paper_orientation_square": "square",
  "message_scale_factor_low": "The document has to be scaled down by {{percent}}% for this paper format. Small adjustments like this are generally okay.",
  "message_scale_factor_very_low": "The document has to be scaled down by {{percent}}% for this paper format. It might become more difficult to feel details or to recognize which element is being touched.",
  "message_scale_factor_too_low": "The document would have to be scaled down by {{percent}}% for this paper format. Such low scaling factors are not supported.",
  "message_scale_factor_too_high": "The document would have to be scaled up by {{percent}}% for this paper format. Such high scaling factors are not supported.",
  "hint_scale_factor_low": "Slightly scaled down",
  "hint_scale_factor_very_low": "Moderately scaled down",
  "hint_scale_factor_too_low": "Scaled down too much",
  "hint_scale_factor_too_high": "Scaled up too much",
  "message_graphic_no_scale": "This graphic contains features that can not be scaled up or down.",
  "button_select_root": "Select document root",
  "error_document_size_unsupported": "The selected braille printer does not support the document size.",
  "error_paper_size_unsupported": "The selected braille printer does not support the selected paper size.",
  "placeholder_no_braille_printer_selected": "Please select a printer model",
  "placeholder_no_paper_size_selected": "Please select a paper size and orientation",
  "label_unknown": "unknown",
  "toast_save_success_header": "Saved",
  "toast_save_graphic_success_message": "The graphic was validated and saved.",
  "toast_save_interactions_success_message": "The interactions were saved and the speech texts generated.",
  "toast_save_graphic_warn_header": "Saved with problems",
  "toast_interactions_saved_warn_message": "File was saved, but could not generate speech for these interactions: {{ failedConversions }}",
  "toast_save_error_header": "Save failed",
  "toast_save_graphic_error_message": "Could not save graphic: {{reason}}",
  "toast_not_implemented_warn_header": "Sorry",
  "toast_not_implemented_warn_message": "This feature is not yet implemented.",
  "label_network_error": "Network error: {{error}}",
  "toast_save_tag_success_message": "The tag has been saved.",
  "toast_save_tag_error_message": "Could not save the tag.",
  "toast_merge_tags_success_message": "The tags have been merged.",
  "toast_merge_tags_error_message": "Could not merge the tags.",  
  "placeholder_nothing_selected": "(nothing selected)",
  "placeholder_no_text": "(no text)",
  "placeholder_empty_text": "(empty text)",
  "prefix_inherited_text": "Inherited from group '{{parent}}' above: {{text}}",
  "label_display_text": "Display text",
  "label_speech_text": "Speech text",
  "label_punctuation": "Punctuation (like <code>{{ punctuation }}</code>) is not well-supported here. Be sure to listen to the generated speech.",
  "label_audio_file": "Audio file",
  "button_done": "Done",
  "button_apply": "Apply",
  "button_plain": "Plain",
  "button_plain_speech": "Plain + Speech",
  "button_recorded_speech": "Recorded speech",
  "button_other_sound": "Other sound",
  "button_edit": "Edit",
  "aria_button_play_status": "Play",
  "aria_button_play_status_unknown": "Play, status is unknown",
  "aria_button_play_status_waiting": "Play, waiting for text generation",
  "aria_button_play_status_converting": "Play, text is currently generated",
  "aria_button_play_status_ready": "Play, text is ready",
  "aria_button_play_status_failed": "Play, text generation failed",
  "aria_button_play_status_postponed": "Play, text generation is postponed",
  "aria_button_play_status_empty": "Play, text is empty",
  "aria_button_play": "Play",
  "aria_button_pause": "Pause",
  "aria_button_rewind": "rewind 1 second",
  "aria_button_skip": "skip 1 second",
  "aria_player_region": "Audio playback controls",
  "label_no_audio": "No Audio selected",
  "label_loading": "Loading...",
  "title_edit": "Edit text",
  "title_edit_desc": "Edit description",
  "title_edit_title": "Edit title",
  "button_choose_file": "Choose file",
  "button_delete_file": "Delete file",
  "toast_file_delete_success_message": "The file has been deleted.",
  "toast_file_delete_error_message": "Could not delete the file.",
  "button_play_file": "Play file",
  "label_voice": "Voice: ",
  "button_edit_script": "Edit interaction",
  "button_edit_schema": "Edit schema",
  "button_edit_data": "Edit data",
  "button_run_script": "Run interaction",
  "button_stop_script": "Stop interaction",
  "header_edit_text_file": "Edit {{title}}",
  "label_indent_with_tab": "Indent text with <kbd>Tab</kbd> key",
  "button_save_text_file": "Save",
  "button_save_and_close_text_file": "Save + close",
  "button_cancel": "Cancel",
  "placeholder_dummy_code": "async function init() {\n\t// Insert your source code here\n}\n",
  "button_disable_script": "Remove all interactions",
  "button_edit_script_title": "Edit title",
  "navi_title": "Tactile Graphics Repository",
  "navi_browse": "Browse",
  "navi_search": "Search",
  "navi_list": "Search",
  "navi_create": "Create",
  "navi_upload": "Upload",
  "navi_manual": "Manuals",
  "navi_help": "Help",
  "navi_my_account": "My account",
  "navi_personal_data": "Personal data",
  "navi_profile": "Personal data",
  "navi_my_graphics": "My Graphics",
  "navi_logout": "Logout",
  "navi_login": "Login",
  "navi_admin": "Admin",
  "navi_donate": "Donate",
  "navi_switch_language": "Deutsch",
  "title_problind_logo": "To the website of problind, community for tactile graphics",
  "tagline_problind": "Community for tactile graphics",
  "title_share_logo": "Share homepage",
  "aria_header_nav": "Main",
  "aria_footer_nav": "Footer",
  "page_validation_result": "Validation results",
  "page_create_template": "Create template",
  "page_create": "Create new",
  "message_login_needed_later": "You may download the template without being logged in. To upload your finished graphic later, you will need to log into your account. To open the new graphic in Designer-App, you also have to log in.",
  "message_login_needed_for_upload": "To upload graphics, you need to log into your account.",
  "header_login_needed": "Login needed",
  "message_login_needed_for_download": "To download graphics, you need to log into your account.",
  "page_upload": "Upload graphic",
  "page_test_result": "Test result",
  "page_show_graphic": "Show graphic",
  "page_show_graphic_title": "Show graphic \"{{title}}\"",
  "page_show_script": "Interactions",
  "page_show_script_title": "Interactions for \"{{title}}\"",
  "page_show_designer": "Designer",
  "page_show_designer_title": "Designer for \"{{title}}\"",
  "page_list": "Browse graphics",
  "page_browse": "Browse graphics and collections",
  "page_landing": "Home page",
  "page_error": "Error",
  "page_message": "Message",
  "page_vue": "Page is loading",
  "page_admin": "Administration and tools",
  "page_login": "Login",
  "page_register": "Register",
  "page_profile": "Profile",
  "page_help": "Help and manuals",
  "page_news": "New features",
  "title_page_standalone": "ProBlind Share",
  "title_page_suffix": " - ProBlind Share",
  "title_page_suffix_tactonom": " - Tactonom",
  "title_page_prefix_local": "LOCAL - ",
  "title_page_prefix_preview": "BETA - ",
  "label_no_license": "No license",
  "label_custom_license": "Special license ({{url}})",
  "link_to_license": "open license text",
  "heading_recommended_licenses": "Recommended Licenses",
  "heading_other_licenses": "Other Licenses",
  "label_error": "Error",
  "error_no_graphic_found": "No graphic found with this identifier",
  "error_no_permission_disable": "You don't have the permission to deactivate this graphic",
  "error_general": "General error",
  "error_authorization": "Authorization error",
  "error_no_permission_page": "You don't have the needed permission to show this page.",
  "error_no_permission_page_anon": "You don't have the needed permission to show this page. Please log in and load this page again.",
  "error_no_permission_page_logged_in": "You don't have the needed permission to show this page. The account which you used to log in does not belong to the authorized user group.",
  "error_no_permission_token": "The needed access token to show this page is missing or invalid in the URL. Please close this page, find and open the Graphic on Share, and open this App from there again.",
  "label_graphic_disabled": "Graphic has been deactivated",
  "label_success": "Success",
  "label_reason_not_logged_in": "You are not logged in. Only logged in users can edit graphics.",
  "label_reason_manager": "Ok, your are a manager.",
  "label_reason_other_user": "Graphic belongs to another user. Only managers can change other users' graphics.",
  "label_reason_owner": "Ok, your are the owner.",
  "label_reason_no_graphic": "Item does not exist.",
  "label_reason_new_graphic": "New graphic.",
  "label_reason_script_manager": "Interaction functionality is only available for manager users.",
  "label_no_matches": "No matching elements can be shown.",
  "heading_results": "Results",
  "heading_filtered_results": "Filtered results",
  "heading_collections": "Graphic collections",
  "label_show_tags": "Show tags",
  "label_filtered_results": "Additional graphics matched the search. However, these are protected by copyright. By provisions of the Marrakesh Treaty these are reserved exclusively for blind and severely visually impaired people. The page <a href=\"$t(problind_url_share_privileged_access)\">\"$t(problind_share_privileged_access)\"</a> contains details about how you can apply for this access.",
  "label_invalid_user_id": "Invalid user id",
  "button_list_by_user": "more graphics and collections by this user",
  "label_to_parent_collection": "to the parent collection",
  "label_license": "License",
  "label_license_info": "Overview of different licenses",
  "label_marrakesh": "Copyright exception",
  "label_marrakesh_true": "applies",
  "label_marrakesh_false": "does not apply",
  "placeholder_marrakesh_license": "does not apply with copyright exception",
  "label_submitted_by": "Submitted by",
  "label_owner": "Owner",
  "label_graphic_author": "{{author}}",
  "label_graphic_author_anonymous": "(Anonymous author)",
  "heading_frequently_used_tags": "Frequently used tags",
  "heading_add_tags": "Add tags",
  "label_proposed_tags": "Proposed tags",
  "label_selected_tags": "Selected tags",
  "label_combined_tags": "Proposed and selected tags",
  "hint_proposed_tags": "Proposals are influenced by the search terms you entered, tags that occur frequently together with your selected tags, and tags that are used frequently in general.",
  "link_show_more_tags": "Show more tags",
  "link_show_fewer_tags": "Show fewer tags",
  "label_taglist_detail": "Tags may only contain letters, digits and the minus sign. Use space or comma as separator.",
  "button_add_tags": "Add tags",
  "button_download": "Download for…",
  "button_download_print": "Print...",
  "button_download_swell": "Swell paper print...",
  "button_download_swell_svg": "Swell paper print (SVG)...",
  "button_download_swell_pdf": "Swell paper print (PDF)...",
  "button_download_edit": "Editing (SVG)",
  "button_download_zip": "Archive (ZIP)",
  "button_download_emboss": "Braille embossing...",
  "button_download_emboss_ibe": "Emboss graphic (IBE)",
  "button_download_emboss_extension": "Emboss graphic ({{extension}})",
  "button_download_emboss_png": "Visual emboss preview (PNG)",
  "button_download_emboss_pdf": "Labels for pasting (PDF)",
  "button_download_emboss_zip": "All together (ZIP)",
  "header_method_and_printer": "Print method and printer model",
  "header_document_size": "Document size and paper format",
  "header_method_printer_size": "Print method and paper format",
  "header_braille_translation_text": "Braille translation (Text)",
  "label_braille_translation_mode": "Choose translation table(s) for {{language}} texts:",
  "label_all_count_languages": "all {{count}} languages",
  "label_braille_translation_mode_document_default": "Default for the respective graphic",
  "label_braille_translation_mode_language_default_6": "Default for '{{language}}', 6-point",
  "label_braille_translation_mode_language_default_8": "Default for '{{language}}', 8-point",
  "label_braille_translation_mode_language_choose": "Choose table from '{{language}}'",
  "label_braille_translation_mode_all_choose": "Choose table from all languages",
  "label_braille_translation_mode_custom": "Enter a custom liblouis table list",
  "label_braille_translation_select_one": "Please select one of the following {{count}} braille translation tables to use:",
  "label_braille_translation_selected_one": "This braille table will be used for translation:",
  "label_braille_translation_selected_multiple": "A combination of the following {{count}} braille tables will be used:",
  "label_braille_translation_selected_none": "The previous selection does not match any translation table(s).",
  "label_braille_custom": "List of liblouis tables, separated by commas:",
  "label_braille_translation_invalid": "The selection of braille tables is empty, incomplete or invalid.",
  "label_braille_translation_deep": "Force selected braille table(s) for all texts in this graphic",
  "label_braille_translation_unspecific_default": "When downloading multiple graphics with default settings, the actual translation tables can't be shown here. For each graphic, that may be the default of the language, or specific to that graphic.",
  "label_braille_translation_multiple_languages": "The collection contains graphics with {{count}} different languages. You can either download all graphics with default braille translation options, or download a subset with only one language and specific braille translation options.",
  "label_braille_translation_all_languages": "All {{totalCount}} graphics (with default settings)",
  "label_braille_translation_only_language": "Only {{language}} graphics ({{subsetCount}} of {{totalCount}})",
  "label_braille_translation_only_language_short": "Only {{language}}",
  "label_braille_translation_colum_selection": "Selection",
  "label_empty_input_not_allowed": "Input must not be empty",
  "label_translation_tables_not_found": "The following translations table(s) could not be found:",
  "column_braille_translation_filename": "filename",
  "column_braille_translation_displayname": "displayname",
  "column_braille_translation_hint": "Hint",
  "column_braille_translation_computer": "computer",
  "column_braille_translation_grade": "grade",
  "column_braille_translation_dots": "dots",
  "column_braille_translation_language": "language",
  "column_braille_translation_contraction": "contraction",
  "label_language_subset": "Download languages:",
  "header_braille_translation_math": "Braille translation (Maths)",
  "label_found_math_input_formats": "Input format(s):",
  "label_math_translation_mode": "Translation mode:",
  "label_math_translation_mode_nemeth": "Nemeth Braille",
  "label_math_translation_mode_plain_text": "Treat as regular text",
  "label_math_translation_mode_plain_text_latex": "Convert to LaTeX",
  "label_math_translation_mode_placeholder_symbol": "Replace by placeholder symbol (no braille output)",
  "label_short_math_translation_mode_nemeth": "Nemeth",
  "label_short_math_translation_mode_plain_text": "Regular text",
  "label_short_math_translation_mode_plain_text_latex": "LaTeX",
  "label_short_math_translation_mode_placeholder_symbol": "Placeholder",
  "placeholder_math_translation_mode": "No math translation defined",
  "label_math_audio_explanation": "For all texts which are marked as math formula, spoken titles are generated automatically.",
  "label_placeholder_incompatible_with_emboss": "The placeholder symbol currently can't used emboss prints.",
  "label_count_options": "({{count}} options)",
  "header_emboss_markers": "How to attach the needed linking-markers after embossing",
  "header_print_settings": "Print settings",
  "header_emboss_preview": "Visual emboss preview",
  "hint_maximize_print_dialog": "Hint: maximize this dialog to show the visual preview right next to the settings.",
  "header_visual_print_preview": "Visual print preview",
  "label_no_preview": "Preview not available",
  "content_emboss_markers_html": "The Tactonom Reader needs visible markers to recognize the embossed graphic. There are multiple ways to provide them:<ul><li><b>Print, cut and paste:</b> Click on '{{button_label}}', and print the PDF file on a regular black-and-white or color printer.</li><li><b>Buy in the shop:</b> If you are located in Germany, you can <a target='tactonomShop' href='https://www.tactonom.com/en/product/link-set-for-braille-printing-graphics/'>buy a linking set in the Tactonom shop</a>. There you also find further instructions.</li><li><b>Combined printing:</b> Soon, we will also support combined braille-and-color printers, so that no additional steps will be needed.</li></ul>",
  "alt_emboss_preview": "Approximate display of the embossing output, where the embossed dots are shown as small black circles.",
  "alt_visual_print_preview": "Approximate display of the print output",
  "file_descriptor_swell": "swell paper",
  "file_descriptor_swell_svg": "swell paper",
  "file_descriptor_swell_pdf": "swell paper",
  "file_descriptor_swell_preview_png": "preview for swell paper",
  "file_descriptor_emboss": "braille embosser",
  "file_descriptor_emboss_dots": "braille embosser",
  "file_descriptor_emboss_preview_png": "preview for emboss printing",
  "file_descriptor_emboss_zip": "braille embosser (all files)",
  "file_descriptor_batch_zip": "collection for printing",
  "file_descriptor_labels": "labels for pasting",
  "file_descriptor_labels_pdf": "labels for pasting",
  "file_descriptor_edit": "edit",
  "file_descriptor_archive": "archive",
  "file_descriptor_revision": "revision {{revision}}",
  "file_descriptor_swell_large_png": "large PNG",
  "file_descriptor_braille_translation_deep": "forced",
  "file_descriptor_direct": "direct",
  "file_descriptor_collection_swell_zip": "Collection for swell paper",
  "file_descriptor_collection_emboss_zip": "Collection for emboss printing",
  "file_descriptor_collection_preview_zip": "Collection als PNG-Vorschau",
  "label_braille_translation_custom_elements": "This graphic has {{count}} element(s) with a custom Braille translation table.",
  "label_braille_translation_custom_elements_option": " Your selection only applies to those elements if you activate the following option:",
  "dialog_title_emboss": "Download graphic for braille embossing",
  "dialog_title_swellprint": "Download graphic for swell paper printing",
  "dialog_title_emboss_batch": "Download {{count}} graphics for braille embossing",
  "dialog_title_swellprint_batch": "Download {{count}} graphics for swell paper printing",
  "button_clone_graphic": "Clone",
  "placeholder_tags": "e.g. biology,math,mobility",
  "label_tags": "Tags",
  "label_unknown_tag": "(unknown tag)",
  "label_untranslated_tag": "(tag without title)",
  "label_new_tag": "(Add new tag '{{title}}')",
  "label_tag_search": "Type to search existing tags. Their titles may be multilingual, and each tag has at least an English title. If you don't find a tag in another language, try to search for English terms.",
  "error_tag_add_restricted": "Manual adding of some special tags is restricted.",
  "error_tag_delete_restricted": "Manual deletion of some special tags is restricted.",
  "label_no_javascript": "We're sorry but the editor doesn't work properly without JavaScript enabled. Please enable it to continue.",
  "foot_company": "Inventivio GmbH",
  "foot_address_1": "Karolinenstr. 13",
  "foot_address_2": "90402 Nürnberg",
  "foot_address_3": "Germany",
  "foot_address_4": "Tel: +49 911 253 0590",
  "foot_address_5": "Email: tactonom-info@inventivio.com",
  "foot_director": "Geschäftsführer",
  "foot_director_names": "Dr. Alexander Hars & Klaus-Peter Hars",
  "foot_registered": "Registered at AG Nürnberg: HRB 25645",
  "foot_tax": "USt-Nr: DE 233 533 159",
  "foot_links": "Links",
  "foot_imprint": "Imprint",
  "foot_privacy": "Data privacy",
  "heading_graphic_list": "Tactile Graphics",
  "label_search_query": "Title",
  "label_search_query_new": "Search terms",
  "button_search": "Search",
  "label_all_languages": "All languages",
  "label_languages": "Language(s): ",
  "placeholder_search": "Part of the title or Id",
  "placeholder_search_new": "Search in titles, descriptions, tags and IDs",
  "heading_filter_graphics": "Filter items",
  "heading_search_results": "Search results",
  "heading_sort_graphics": "Sort items",
  "heading_graphics_list_options": "Display options",
  "label_filter_hidden": "Hidden items",
  "label_filter_hidden_all": "Show all",
  "label_filter_hidden_only": "Only hidden",
  "label_filter_hidden_no": "No hidden",
  "label_filter_disabled": "Deactivated items",
  "label_filter_disabled_all": "Show all",
  "label_filter_disabled_only": "Only deactivated",
  "label_filter_disabled_no": "No deactivated",
  "label_filter_marrakesh": "Marrakesh-restrictions",
  "label_filter_marrakesh_all": "Show all",
  "label_filter_marrakesh_only": "Only with restrictions",
  "label_filter_marrakesh_no": "Only without restrictions",
  "label_filter_may_edit": "Editing permission",
  "label_filter_may_edit_all": "Show all",
  "label_filter_may_edit_only": "Only items I may edit",
  "label_filter_may_edit_no": "Only items I may not edit",
  "label_filter_paper_size": "Printable on paper size",
  "label_filter_paper_size_all": "All sizes",
  "label_filter_sort_order": "Order by",
  "label_filter_sort_order_recently_modified": "Recently modified",
  "label_filter_sort_order_recently_added": "Recently added",
  "label_filter_sort_order_modified": "Recently modified",
  "label_filter_sort_order_added": "Recently added",
  "label_filter_sort_order_most_popular": "Most popular",
  "label_filter_sort_order_alphabet": "Alphabetical",
  "label_filter_sort_order_longest_title": "Longest title",
  "aria_suffix_tag_unselected": "inactive filter",
  "aria_suffix_tag_selected": "active filter",
  "aria_suffix_tag_negative": "negated filter",
  "aria_suffix_tag": "tag",
  "aria_language_prefix": "Language: ",
  "language_current_locale": "Unknown",
  "language_current_locale_en": "English",
  "language_current_locale_de": "German",
  "language_current_locale_fr": "French",
  "language_current_locale_pt": "Portuguese",
  "language_current_locale_es": "Spanish",
  "language_current_locale_it": "Italian",
  "language_current_locale_nl": "Dutch",
  "language_current_locale_tr": "Turkish",
  "language_current_locale_ar": "Arabic",
  "language_current_locale_da": "Danish",
  "language_current_locale_sv": "Swedish",
  "language_current_locale_nb": "Norwegian",
  "language_current_locale_no": "Norwegian",
  "language_current_locale_fi": "Finnish",
  "language_current_locale_hu": "Hungarian",
  "language_current_locale_pl": "Polish",
  "language_current_locale_el": "Greek",
  "language_native_locale": "Unknown",
  "language_native_locale_en": "English",
  "language_native_locale_de": "Deutsch",
  "language_native_locale_fr": "Français",
  "language_native_locale_pt": "Português",
  "language_native_locale_es": "Español",
  "language_native_locale_it": "Italiano",
  "language_native_locale_nl": "Nederlands",
  "language_native_locale_tr": "Türkçe",
  "language_native_locale_ar": "العربية",
  "language_native_locale_da": "Dansk",
  "language_native_locale_sv": "Svenska",
  "language_native_locale_nb": "Norsk bokmål",
  "language_native_locale_no": "Norsk bokmål",
  "language_native_locale_fi": "Suomi",
  "language_native_locale_hu": "Magyar",
  "language_native_locale_pl": "Polski",
  "language_native_locale_el": "Ελληνικά",
  "heading_your_profile": "Your profile",
  "toast_profile_update_success_message": "The profile has been updated.",
  "toast_profile_update_error_header": "Problem with profile update",
  "toast_profile_update_error_message": "During the update of your profile information, this problem occurred: {{reason}}",
  "toast_profile_register_error_header": "Problem with registering",
  "toast_profile_register_error_message": "While processing your registration, this problem has happened: {{reason}}",
  "label_account_status": "Status",
  "label_account_language": "UI language",
  "label_first_name": "First name",
  "placeholder_first_name": "Enter first name",
  "label_first_name_detail": "Your first name. This name will not be visible to the public on this web site.",
  "label_last_name": "Last name",
  "placeholder_last_name": "Enter last name",
  "label_last_name_detail": "Your last name. This name will not be visible to the public on this web site.",
  "label_full_name": "Full name",
  "label_full_name_detail": "The name will not be visible to the public on this web site.",
  "label_email": "Email",
  "placeholder_email": "Enter email",
  "label_email_detail": "Will be used to identify you when logging in. A confirmation email will be sent to this address.",
  "label_display_name": "Display name",
  "placeholder_display_name": "Enter display name",
  "label_display_name_detail": "This name is visible to other users, e.g. as the author if you upload a graphic.",
  "label_company": "Company",
  "placeholder_company": "Enter company",
  "label_company_detail": "This field is optional.",
  "label_marrakesh_beneficiary": "Beneficiary of the Marrakesh Treaty",
  "label_marrakesh_beneficiary_short": "Beneficiary (Marr.)",
  "label_marrakesh_beneficiary_detail": "Some graphics are restricted by copyright and only available to beneficiaries of the <a href=\"https://www.wipo.int/marrakesh_treaty/en/\">Marrakesh Treaty</a>. The page <a href=\"$t(problind_url_share_privileged_access)\">$t(problind_share_privileged_access)</a> contains details about how you can apply for this access.",
  "marrakesh_not_entitled": "not entitled for benefit",
  "marrakesh_entitled": "entitled for benefit (blind or severely visually impaired person)",
  "marrakesh_on_behalf": "entitled for benefit (on behalf of someone)",
  "marrakesh_unknown": "unknown",
  "button_update_profile": "Update",
  "toast_update_profile_success_message": "Your account has been updated.",
  "toast_update_profile_no_change_success_message": "No changes to perform.",
  "toast_update_profile_email_success_message": "Your account has been updated - But your email address will not be changed until you click the confirmation link that we have just sent to your new address. Until then, use the previous email address to log in.",
  "toast_update_profile_email_error_message": "Your account has been updated, but your new email address could not be reached for confirmation. Please use another, valid email address. Continue to use the previous email address to log in.",
  "toast_update_profile_display_name_error_message": "The display name may not be empty, and must be at least 3 characters long.",
  "toast_update_profile_email_taken_error_message": "Your account has been updated, but your email address could not be changed, because it is already assigned to another user. Please use another, valid email address. Continue to use the previous email address to log in.",
  "message_email_pending": "Your old email address is shown here, until you click the confirmation link we sent you.",
  "heading_register": "Register",
  "heading_required_fields": "Required fields",
  "label_password": "Password",
  "label_better_password_suggestion": "Suggestions for a better password",
  "placeholder_password_profile": "Leave blank, unless you want to change your password",
  "label_password_detail": "A minimum of 8 characters. Please use a random password and a password manager.",
  "button_register": "Register",
  "message_register_error_empty": "Email and password may not be empty",
  "message_register_error_email_too_long": "Email address is too long. Please use a different email address",
  "message_register_error_password_too_short": "Password must be at minimum 8 characters long",
  "message_register_error_email_exists": "An account with this email already exists",
  "message_register_error_email_send": "Your account has been created, but the email you provided could not be reached. Please log in now with your provided email address and password, and then change your email address to a valid one.",
  "message_register_ok": "Account has been created. You can login now with your email address and password. Also, a confirmation link has been sent to your email address. Please open that email and click on the link.",
  "message_profile_not_logged_in": "You must be logged in to edit your profile. If you just changed your email address and/or password, you have been logged out automatically.",
  "message_register_logged_in": "You are already logged in. If you really want to register an additional account, you have to log out first.",
  "header_validation_upload": "Validation and upload",
  "label_upload": "Upload an SVG file",
  "button_upload": "Upload file",
  "checkbox_autodelete": "Auto-delete after 2 hours",
  "checkbox_autohide": "Hide this graphic",
  "label_auto_options_download": "The options for deleting or hiding new graphics do not apply to template downloads. Instead, the options must be used later, when uploading the graphic.",
  "header_create": "Create a new tactile graphic template",
  "header_create_graphic": "Create a new tactile graphic",
  "header_create_collection": "Create a new collection",
  "label_title": "Title",
  "label_description": "Description",
  "label_title_detail": "Your svg file will be initialized to the title. Leave blank if you don't know it yet.",
  "label_language": "Language",
  "button_download_template": "Download template",
  "button_create_tip_graphic": "Create TIP graphic",
  "button_create_collection": "Create the collection",
  "label_marrakesh_detail": "The graphic is protected by copyright (rights holder: me or third party). Therefore, according to the Marrakesh Treaty, it may only be used by blind people.",
  "label_marrakesh_more": "More...",
  "label_marrakesh_less": "Less",
  "label_marrakesh_detail_rest": "It may neither be translated into other languages nor changed graphically or textually. Therefore, the graphic only benefits a small number of blind people. ProBlind recommends to choose the CC-BY-4.0 license instead of the copyright exception (strict copyright protection).",
  "confirm_apply_marrakesh_message": "With this option you prevent the graphic from being translated into other languages and from being changed graphically or textually. Therefore, only a small number of blind people will benefit from it. ProBlind recommends choosing the CC-BY-4.0 license instead of the copyright exception (strict copyright protection). Are you sure you want to choose the copyright exception?",
  "confirm_apply_marrakesh_header": "Really activate the copyright exception?",
  "toast_download_template_success_header": "Download successful",
  "toast_download_template_success_message": "The template has been created and downloaded.",
  "toast_download_template_error_header": "Download failed",
  "toast_download_template_error_message": "Error during creation or download of the template: {{reason}}",
  "toast_upload_graphic_success_header": "Upload successful",
  "toast_upload_graphic_success_message": "The graphic has been uploaded.",
  "toast_upload_graphic_error_header": "Upload failed",
  "toast_upload_graphic_error_message": "Error during the upload of the graphic: {{reason}}",
  "toast_commission_graphic_success_header": "Successfully commissioned",
  "toast_commission_graphic_success_message": "You can enter the contents for the graphic shortly.",
  "toast_commission_graphic_error_header": "Commissioning failed",
  "toast_commission_graphic_error_message": "There was an error while commissioning the graphic: {{reason}}",
  "heading_login": "Login",
  "heading_login_register": "Login or register",
  "label_email_address": "Email address",
  "label_email_address_short": "Email",
  "placeholder_email_address": "Enter email address",
  "label_email_address_detail": "Please enter your email address",
  "label_email_address_detail_login": "If you recently changed your email address: Click on the link in the confirmation mail, then use the new email address to log in. If you did not get the confirmation email, continue to use your old email address.",
  "button_login": "Login",
  "label_or": "or",
  "toast_login_error_header": "Login error",
  "toast_login_error_message": "Invalid email address or password. If needed, click on 'Forgot your password?'.",
  "toast_login_unknown_error_message": "Error due to unknown reason.",
  "toast_login_success_message": "You are now logged in.",
  "toast_logout_success_message": "You are now logged out.",
  "toast_login_dev_server_error_message": "Login is not available in the Vue dev server. Use localhost:9005 instead to log in, and then return to the dev server on localhost:5174.",
  "toast_logout_error_message": "Could not perform logout.",
  "heading_clone": "Clone graphic '{{title}}'",
  "label_title_new": "Title of the new graphic",
  "placeholder_title": "Enter title",
  "placeholder_description": "Enter description",
  "value_cloned_title": "Clone of {{title}}",
  "label_cloning": "Graphic is being cloned...",
  "label_cloning_translation_takes_time": "The automatic translation may take up to 45 seconds.",
  "toast_clone_graphic_error_header": "Error while cloning",
  "toast_clone_graphic_error_message": "An unknown error occurred.",
  "toast_clone_graphic_popup_success_header": "Cloning successful",
  "toast_clone_graphic_popup_success_message": "The cloned graphic is displayed in a new tab or window.",
  "message_clone_unsure_title": "Result unclear",
  "message_clone_unsure_text": "There were unforeseen results during the cloning of the graphic. Please check the graphics list to see if the graphic has been cloned or not.",
  "label_clone_unsaved_note": "The graphic has unsaved changes. We recommend that you first save the graphic, and then clone it.",
  "toast_clone_graphic_popup_error_header": "Popup was blocked",
  "toast_clone_graphic_popup_error_message": "The cloned graphic should be shown in a new window or tab, but a pop-up-blocker prevented that. Please check the message underneath the browser's address bar.",
  "heading_accounts": "Account",
  "button_submit_file": "Submit file",
  "heading_tag_tree": "Tag tree",
  "label_show_empty_values": "Also show empty values",
  "label_metadata_creator": "Creator",
  "placeholder_metadata_creator": "",
  "label_metadata_rights": "Rights holder",
  "placeholder_metadata_rights": "",
  "label_metadata_publisher": "Publisher",
  "placeholder_metadata_publisher": "",
  "label_metadata_source": "Source",
  "placeholder_metadata_source": "",
  "problind_share": "Share",
  "problind_share_privileged_access": "Privileged access for blind users",
  "problind_share_about": "About Share",
  "problind_home": "Home",
  "problind_about": "About ProBlind",
  "problind_contribute": "Get Involved",
  "problind_contribute_create": "Create",
  "problind_contribute_edit": "Edit",
  "problind_contribute_ideas": "Idea form",
  "problind_contribute_facts": "Interesting facts",
  "problind_english": "English",
  "problind_german": "Deutsch",
  "problind_other_language": "Deutsch",
  "problind_donate": "Donate",
  "problind_quick_links": "Quick links",
  "problind_contact": "Contact",
  "problind_imprint": "Imprint",
  "problind_privacy": "Privacy policy",
  "problind_faq": "FAQ",
  "problind_footer": "Copyright 2024 ProBlind e. V., All Rights Reserved",
  "problind_menu_welcome": "Welcome, {{name}}",
  "problind_menu_dashboard": "Dashboard",
  "problind_menu_contributions": "My contributions",
  "problind_menu_following": "Following",
  "problind_menu_signout": "Sign out",
  "problind_language": "Language",
  "problind_language_code_same": "en",
  "problind_language_code_other": "de",
  "problind_url_home": "https://www.problind.org/en/",
  "problind_url_share_about": "https://www.problind.org/en/aboutshare/",
  "problind_url_share_privileged_access": "https://www.problind.org/en/privileged-access-for-blind-users/",
  "problind_url_about": "https://www.problind.org/en/aboutproblind/",
  "problind_url_contribute": "https://www.problind.org/en/getinvolved/",
  "problind_url_contribute_create": "https://www.problind.org/en/create/",
  "problind_url_contribute_edit": "https://www.problind.org/en/edit/",
  "problind_url_contribute_ideas": "https://www.problind.org/en/ideaform/",
  "problind_url_contribute_facts": "https://www.problind.org/en/interestingfacts/",
  "problind_url_other_language": "https://www.problind.org/de/",
  "problind_url_manual": "https://www.problind.org/en/manuals/",
  "problind_url_donate": "https://www.problind.org/en/donate/",
  "problind_url_contact": "https://www.problind.org/en/contact/",
  "problind_url_faq": "https://www.problind.org/en/faq2/",
  "problind_url_privacy": "https://www.problind.org/en/privacypolicy/",
  "problind_url_imprint": "https://www.problind.org/en/imprint/",
  "label_simplequiz_questions": "Tasks (Q & A):",
  "label_simplequiz_max_questions": "Question limit:",
  "label_simplequiz_order": "Order:",
  "label_simplequiz_random": "Random",
  "label_simplequiz_random_order": "Random order",
  "label_find_pairs_announce_partner": "Repeat solved answer",
  "hint_find_pairs_announce_partner": "If a pair has already been found, announce the title of the second element, even if the first element is tapped.",
  "label_questions": "Questions:",
  "button_simplequiz_add_question": "New task",
  "toast_add_area_success_header": "Area selected",
  "toast_add_area_success_message": "You may select more areas.",
  "button_stop_selection": "Finish selection",
  "button_add_questions": "Add tasks from the graphic",
  "button_add_script": "Add interaction",
  "button_remove_script": "Delete interaction",
  "label_script_choice": "Select interaction:",
  "title_script_default": "Interaction #{{num}}",
  "label_script_title": "Interaction title:",
  "button_select_only": "Select only",
  "button_edit_title": "Edit title",
  "button_edit_description": "Edit description",
  "label_creation_date": "Created on",
  "label_modification_date": "Last modified on",
  "header_metadata_common": "General information",
  "header_metadata_tags": "Tags",
  "header_metadata_collections": "Collections",
  "header_metadata_owner_and_license": "Owner, sources and license",
  "header_metadata_license": "License",
  "header_metadata_creator": "Authorship",
  "header_metadata_language_and_text": "Language and text",
  "header_metadata_history_table": "History of changes (table)",
  "header_metadata_history_graph": "History of changes (graph)",
  "header_metadata_clones": "Clones",
  "header_metadata_metrics": "Metrics",
  "header_history": "Changes",
  "header_metadata_revision_graph": "Revision graph",
  "header_clones": "Clones",
  "header_metrics": "Metrics",
  "label_item_in_no_collections": "This item is not contained in any collection that is visible to you.",
  "label_item_in_collections": "This item is contained in {{count}} collection(s):",
  "button_add_to_followin_collection": "Add this to the following collection:",
  "label_graphic_actions": "Graphic actions:",
  "button_disable": "Delete",
  "button_re_enable": "Restore",
  "confirm_disable_graphic_header": "Deactivate graphic irrevocably",
  "confirm_disable_graphic_message": "This graphic will be deactivated. It will no longer be available for viewing or editing. It will remain available for download by Readers on which a printout of this graphic is placed for a certain time, but will eventually be deleted. This action can not be undone.",
  "message_disable_graphic_success": "The graphic has been deactivated can no longer be shown.",
  "message_disable_collection_success":  "The collection has been deactivated can no longer be shown.",
  "message_disable_graphic_error": "Could not deactivate the graphic. Reason: {{reason}}",
  "toast_disable_graphic_success_header": "Success",
  "toast_disable_graphic_success_message": "The graphic has been deactivated.",
  "toast_disable_graphic_error_header": "Error",
  "toast_disable_graphic_error_message": "Could not deactivate the graphic. Reason: {{reason}}",
  "button_accept_disable": "Deactivate",
  "button_reject_disable": "Cancel",
  "button_interactions_app": "Interactions-App",
  "button_designer_app": "Designer-App",
  "button_designer_app_tip": "Designer-App (TIP)",
  "button_regular_editor": "Back to regular editor",
  "button_back_to_share": "Back to Share",
  "menu_app_deployed": "Server version",
  "menu_app_deployed_preview": "Beta version",
  "menu_app_local": "Local version",
  "button_hide_graphic": "Hide",
  "confirm_hide_graphic_header": "Hide graphic",
  "confirm_hide_graphic_message": "This graphic will be hidden. Other users will not be able to see find it in the graphic list, except if they have special rights to access it. It will remain available for download by Readers on which a printout of this graphic is placed.",
  "confirm_hide_accept": "Hide",
  "confirm_hide_reject": "Cancel",
  "toast_hide_graphic_success_message": "The graphic has been hidden.",
  "toast_hide_graphic_error_message": "The graphic could not be hidden. Reason: {{reason}}",
  "confirm_hide_collection_header": "Hide collection",
  "confirm_hide_collection_message": "This graphic will be hidden. Other users will not be able to see find it in the graphic list, except if they have special rights to access it. The visibility of the graphics and/or collections within the hidden collection remains unchanged.",
  "toast_hide_collection_success_message": "The collection has been hidden.",
  "toast_hide_collection_error_message": "The collection could not be hidden. Reason: {{reason}}",
  "tooltip_graphic_hidden": "hidden",
  "tooltip_graphic_disabled": "deactivated",
  "tooltip_graphic_marrakesh": "only for beneficiaries",
  "tooltip_graphic_edit_others_graphic": "other user's graphic may be edited",
  "tooltip_graphic_has_invites": "has invites",
  "confirm_hide_graphic_limit_reached_header": "Can't hide another graphic",
  "confirm_hide_graphic_limit_reached_message": "You are allowed to hide {{maxHidden}} graphics, and already have {{currentHidden}} hidden graphics. You may publish some of your hidden graphics first, and then try again. If you want to be able to hide more graphics in general, please contact us.",
  "confirm_hide_graphic_limit_reached_accept": "List hidden graphics",
  "confirm_hide_graphic_limit_reached_reject": "OK",
  "button_publish_graphic": "Publish",
  "confirm_publish_graphic_header": "Publish graphic",
  "confirm_publish_graphic_message": "This graphic will no longer be hidden. Other users will be able to see find it in the graphic list, except if it is restricted by the Copyright and the Marrakesh Treaty.",
  "confirm_publish_collection_header": "Publish collection",
  "confirm_publish_collection_message": "Other users will be able to view it.",
  "confirm_publish_accept": "Publish",
  "confirm_publish_reject": "Cancel",
  "toast_success_header": "Success",
  "toast_success_message": "The operation was successful.",
  "toast_error_header": "Error",
  "toast_warn_header": "Warning",
  "toast_info_header": "Notice",
  "toast_error_message": "Reason of the error: {{reason}}",
  "toast_publish_graphic_success_message": "The graphic has been published.",
  "toast_publish_graphic_error_message": "The graphic could not be published. Reason: {{reason}}",
  "toast_publish_collection_success_message": "The collection has been published.",
  "toast_publish_collection_error_message": "The collection could not be hidden. Reason: {{reason}}",
  "header_edit_tag": "Edit tag",
  "button_save_tag": "Save tag",
  "button_new_tag": "New tag",
  "button_delete_tag": "Delete",
  "button_delete_named_tag": "Delete tag '{{tag}}'",
  "confirm_modify_restricted_tag_message": "Usually, this tag is managed automatically. Really modify it manually?",
  "confirm_modify_restricted_tag_header": "Add or remove special tag?",
  "label_no_tags": "No tags present.",
  "error_tag_delete_not_empty": "Can't delete tag that is still used by graphics.",
  "header_tag_language": "Language",
  "header_tag_title": "Title",
  "header_tag_description": "Description",
  "label_tag_translations": "Every tag needs (at least) a title in English, and the language of the graphic (if it differs). You may add as many additional translations as you like.",
  "button_add_translation": "New Translation",
  "button_delete_translation": "Delete translation",
  "button_translate_tags": "Automatic translation",
  "button_auto_fix_tags": "Fix errors",
  "label_tag_language_own": "Language for own tag translation",
  "placeholder_tag_language": "No language",
  "label_tag_title": "Title for the tag in {{language}}, mandatory",
  "label_tag_title_no_lang": "Title for the tag, mandatory",
  "label_tag_description": "Description for the tag in {{language}}, optional",
  "label_tag_description_no_lang": "Description for the tag, optional",
  "label_tag_search_enter_text": "Enter text to search for tags to add, or to create a new tag.",
  "label_tag_search_found_too_many": "Found {{count}} matching tags. Only the first few are displayed. Please refine your search.",
  "label_tag_search_found":  "Found {{count}} matching tags:",
  "label_tag_search_found_one": "Found one matching tag. Press 'Enter' to add:",
  "label_tag_search_found_none": "No matching tags.",
  "header_graphics_count": "Graphics",
  "header_restrictions": "Special properties",
  "special_restriction_dont_suggest_title": "Don't suggest (?)",
  "special_restriction_dont_suggest_description": "This functionality of this property is not yet specified.",
  "special_restriction_dont_filter_title": "Don't filter (?)",
  "special_restriction_dont_filter_description": "This functionality of this property is not yet specified.",
  "special_restriction_restrict_add_title": "Restrict add",
  "special_restriction_restrict_add_description": "The tag can only be added by automated processes, not by direct actions of a user.",
  "special_restriction_restrict_delete_title": "Restrict delete",
  "special_restriction_restrict_delete_description": "The tag can only be deleted by automated processes, not by direct actions of a user.",
  "special_restriction_visible_for_admins_only_title": "Visible for admins only",
  "special_restriction_visible_for_admins_only_description": "Multiple 'Visible for ... only'-properties can be combined.",
  "special_restriction_visible_for_managers_only_title": "Visible for managers only",
  "special_restriction_visible_for_managers_only_description": "Multiple 'Visible for ... only'-properties can be combined.",
  "special_restriction_visible_for_tip_only_title": "Visible for members of TIP only",
  "special_restriction_visible_for_tip_only_description": "Multiple 'Visible for ... only'-properties can be combined.",
  "special_restriction_visible_for_biotact_only_title": "Visible for members of BioTact or BioTact-managers only",
  "special_restriction_visible_for_biotact_only_description": "Multiple 'Visible for ... only'-properties can be combined.",
  "header_actions": "Actions",
  "header_multiple_tags_actions": "Actions on all {{count}} selected tags",
  "button_multiple_tags_delete": "Delete {{count}} tags",
  "button_multiple_tags_add_property": "Add to {{count}} tags",
  "button_multiple_tags_remove_property": "Remove from {{count}} tags",
  "button_multiple_tags_merge": "Merge {{count}} tags",
  "label_show_descriptions": "Show descriptions",
  "label_show_translations": "Show translations",
  "toast_tag_translate_error_header": "Error during translation",
  "toast_tag_translate_error_message_one": "There was {{count}} error during translation.",
  "toast_tag_translate_error_message_other": "There were {{count}} errors during translation.",
  "label_auto_translate": "Use automatic translation from '{{srclang}}' to '{{dstlang}}'?",
  "label_auto_translate_speech": "translate spoken text (including interactions)",
  "label_auto_translate_text": "translate written text",
  "label_auto_translate_similar": "Automatic translation from language variant '{{srclang}}' to similar language variant '{{dstlang}}' is not recommended.",
  "label_auto_translate_unresolved_comments": "The source graphic already is the result of automatic translation, and contains {{count}} unresolved translation comments. Please check those comments before creating another translation, and if possible, delete all comments that are resolved.",
  "label_auto_translate_custom_languages": "This graphic has {{count}} elements with a custom language. Translating these elements will cause problems!",
  "label_auto_translate_custom_voices": "This graphic has {{count}} elements with a custom voice. Translating these elements will cause problems!",
  "label_auto_translate_custom_braille_tables": "This graphic has {{count}} elements with a custom Braille translation table. During translation, they will be reverted to the default table.",
  "label_auto_translate_interactions_language_unsupported": "The language {{language}} is not yet supported for interactions. The translated interactions may therefor contain English content and / or English pronunciation.",
  "label_comment_text": "Comment",
  "button_delete_comment": "Delete comment",
  "label_auto_translate_note": "Please check the text list after the automatic translation has finished. Text elements which could not be translated successfully will be highlighted by a special flag symbol. It is advised to check the linguistic correctness of all text elements.",
  "label_no_interactions_translation_note": "Currently interactions can not yet be translated. Thus they will not be available in the cloned graphic. This will change in the future.",
  "placeholder_auto_translate_title": "(will be translated automatically)",
  "label_language_not_changed": "This matches the original language of the graphic.",
  "label_no_auto_translate_note": "Automatic translation is turned off. After cloning, you will have to translate each text by yourself.",
  "warning_auto_translate_es_mx": "Translation into Mexican Spanish is possible, but the pronunciation will be done in European Spanish anyway.",
  "warning_auto_translate_es_us": "Pronunciation of US-American Spanish is possible, but the translation will be performed into European Spanish.",
  "label_translation_service": "Translation service:",
  "label_translation_setting_math": "Optimize for math",
  "option_translation_service_gemini": "LLM: Gemini by Google",
  "option_translation_service_openai": "LLM: ChatGPT by OpenAI",
  "option_translation_service_amazon": "Classic: Amazon Translate",
  "label_playback_no_title": "(no title)",
  "label_playback_no_entry": "(no entry)",
  "label_custom_sound_displaytext": "Custom sound for '{{displaytext}}'",
  "label_custom_sound": "Custom sound",
  "error_play": "Play error",
  "error_tag_language_required": "You must choose a language",
  "error_tag_title_required": "Each tag must have a title",
  "error_tag_title_uppercase": "Must start with an uppercase letter",
  "error_tag_title_letters_digits": "Must only contain letters, digits and hyphens",
  "error_tag_title_hyphenated": "Must consist of words, separated with hyphens \"-\"",
  "error_tag_title_uppercase_word_start": "Each word must start with an uppercase letter or digit",
  "error_tag_title_lowercase_word_end": "Only the first letter of each word may be uppercase",
  "label_max_file_size": "Maximum file size:",
  "error_file_too_big": "The file is too big. The maximum allowed file size is {{max_size}}.",
  "error_file_upload": "File could not be uploaded.",
  "error_file_upload_invalid_data": "Invalid data found when processing input (damaged or wrong format).",
  "error_file_upload_no_audio": "Input file did not contain audio data.",
  "toast_file_upload_header": "Upload",
  "toast_file_upload_success_message": "File was uploaded.",
  "toast_file_upload_error_message": "File could not be uploaded. Reason: {{reason}}",
  "toast_load_graphic_list_error_header": "Load-Error",
  "toast_load_graphic_list_error_message": "Error while loading the list of graphics.",
  "label_only_by_author": "Only show graphics by {{author}}",
  "label_only_by_me": "Only show my own graphics",
  "label_only_hidden": "Only show hidden graphics",
  "label_filter_in_no_collection": "Contained in no collection",
  "label_invert_filter": "invert filter",
  "button_remove_filter": "Remove filter",
  "text_user_noname": "user #{{userId}}",
  "text_user_nobody": "Nobody",
  "text_user_loading": "user #{{userId}} (name is loading...)",
  "label_updater_list_desc": "This will iterate over all graphics and perform the following updates:",
  "label_updater_prefix": "Only update graphics with IDs starting with these characters:",
  "label_socket_state": "Socket status: ",
  "label_socket_state_readyState0": "connecting...",
  "label_socket_state_readyState1": "connected",
  "label_socket_state_readyState2": "closing...",
  "label_socket_state_readyState3": "closed",
  "label_socket_state_readyState5": "unknown",
  "header_log": "Log",
  "button_start_updater": "Update graphics",
  "heading_stats_loading": "Loading general stats…",
  "label_stats_loading": "Loading the statistics may take a while. Please stand by…",
  "heading_metrics_loading": "Loading graphic metrics…",
  "label_metrics_loading": "Loading the metrics may take a while. Please stand by…",
  "footer_graphics_loading": "More graphics are being loaded…",
  "heading_stats_graphics": "Graphics",
  "label_stats_graphic_count": "Total count",
  "label_stats_graphic_of_which": "Of which",
  "label_stats_graphic_count_active": "Active",
  "label_stats_graphic_count_hidden": "Hidden",
  "label_stats_graphic_count_disabled": "Deactivated",
  "label_stats_graphic_count_marrakesh": "Marrakesh restricted",
  "label_stats_graphic_count_with_tags": "With tags",
  "label_stats_graphic_count_by_language": "By language",
  "heading_stats_users": "Users",
  "label_stats_user_count": "Total count",
  "heading_stats_tags": "Tags",
  "label_stats_tag_count": "Total count",
  "label_admin_legacy_desc": "Some of these admin pages are old and have not been kept up-to-date for a while.",
  "label_admin_legacy_table": "All graphics as csv-table (may take several minutes to load)",
  "label_admin_legacy_manage_accounts": "Manage users",
  "label_admin_manage_accounts": "Users",
  "header_icon_list": "Icons used in this application (only visible to managers)",
  "label_icon_list": "This is a list of all icons from <a href=\"https://primefaces.org/primevue/icons\">PrimeIcons</a> which are currently used by this application. It can be used by our designers to search for replacements. To save an icon: right click, then choose <i>Save target as...</i>.",
  "label_loading_metadata": "The graphic's meta data is loading.",
  "label_loading_timed_out": "Loading the meta data takes very long. Maybe the graphic file is damaged and does not contain complete meta data. You may try to show the available data.",
  "button_show_partial_data": "Show incomplete data",
  "button_revoke_invite": "Revoke invite",
  "label_invite_account": "User",
  "label_invite_role": "Role",
  "button_add_invite": "Send invite",
  "role_invite_none": "Just notify",
  "role_invite_view": "View",
  "role_invite_edit": "Edit",
  "hint_invite_none": "The invitee will be notified by mail, with the request to view this graphic. They do not get any additional access rights.",
  "hint_invite_view": "The invitee may view the graphic, even if there are restrictions in place that would normally prevent that (copy right, hidden graphic, etc.).",
  "hint_invite_edit": "The invitee may edit the graphic as if they were its owner. This applies even if if there are restrictions in place that would normally prevent viewing the graphic (copy right, hidden graphic, etc.). The user may also create or delete invites for this graphic.",
  "label_invite_account_hint": "Enter the full email address of a user, which they have used to register at ProBlind Share.",
  "header_invite_add": "Add invite",
  "header_invite_current": "Current invites",
  "label_no_invites": "No invites",
  "toast_add_invite_success_header": "User invited",
  "toast_add_invite_success_message": "The user has been invited successfully.",
  "toast_add_invite_error_header": "Error",
  "toast_add_invite_error_message": "Could not invite the user. Reason: {{reason}}",
  "toast_add_invite_email_error_message": "The user has been invited, but they could not be notified, because their email address is unconfirmed. Please notify the user directly.",
  "toast_revoke_invite_success_header": "Invitation revoked",
  "toast_revoke_invite_success_message": "The invitation has been revoked successfully.",
  "toast_revoke_invite_error_header": "Error",
  "toast_revoke_invite_error_message": "Could not revoke the invite. Reason: {{reason}}",
  "confirm_revoke_self_invite_header": "Remove own invite",
  "confirm_revoke_self_invite_message": "You are going to remove your own invite, and thus lose the right to manage invites for this graphic. You cannot undo this yourself.",
  "confirm_revoke_self_invite_accept": "Remove own invite",
  "confirm_revoke_self_invite_reject": "Cancel",
  "header_graphic_load_error": "Error",
  "message_graphic_load_error": "The graphic could not be loaded",
  "header_error_details": "Reason:",
  "header_error_details_none": "Reason unknown.",
  "mail_invited_graphic_view_subject": "Invitation to view graphic \"{{title}}\"",
  "mail_invited_graphic_view_text_plain": "Dear {{invitee}},\nyou have been invited by {{owner}} to view the graphic {{title}} in ProBlind Share. You can find the graphic at {{url}}. Possibly, you need to be logged in to view the graphic.\n\nSincerely, your ProBlind Team",
  "mail_invited_graphic_view_text_html": "Dear {{invitee}},<br/>you have been invited by {{owner}} to view the graphic <a href=\"{{url}}\">{{title}}</a> in ProBlind Share:<br/><br/><img src='cid:preview.png' /><br/><br/>Possibly, you need to be logged in to view the graphic.<br/><br/>Sincerely, your ProBlind Team",
  "mail_invited_graphic_edit_subject": "Invitation to edit graphic \"{{title}}\"",
  "mail_invited_graphic_edit_text_plain": "Dear {{invitee}},\nyou have been invited by {{owner}} to edit the graphic {{title}} in ProBlind Share. You can find the graphic at {{url}}. You need to be logged in to edit the graphic.\n\nSincerely, your ProBlind Team",
  "mail_invited_graphic_edit_text_html": "Dear {{invitee}},<br/>you have been invited by {{owner}} to edit the graphic <a href=\"{{url}}\">{{title}}</a> in ProBlind Share:<br/><br/><img src='cid:preview.png' /><br/><br/>You need to be logged in to edit the graphic.<br/><br/>Sincerely, your ProBlind Team",
  "mail_invited_collection_view_subject": "Invitation to view collection \"{{title}}\"",
  "mail_invited_collection_view_text_plain": "Dear {{invitee}},\nyou have been invited by {{owner}} to view the collection {{title}} in ProBlind Share. You can find the collection at {{url}}. Possibly, you need to be logged in to view the collection.\n\nSincerely, your ProBlind Team",
  "mail_invited_collection_view_text_html": "Dear {{invitee}},<br/>you have been invited by {{owner}} to view the collection <a href=\"{{url}}\">{{title}}</a> in ProBlind Share.<br/><br/>Possibly, you need to be logged in to view the collection.<br/><br/>Sincerely, your ProBlind Team",
  "mail_invited_collection_edit_subject": "Invitation to edit graphic \"{{title}}\"",
  "mail_invited_collection_edit_text_plain": "Dear {{invitee}},\nyou have been invited by {{owner}} to edit the collection {{title}} in ProBlind Share. You can find the collection at {{url}}. You need to be logged in to edit the collection.\n\nSincerely, your ProBlind Team",
  "mail_invited_collection_edit_text_html": "Dear {{invitee}},<br/>you have been invited by {{owner}} to edit the collection <a href=\"{{url}}\">{{title}}</a> in ProBlind Share.<br/><br/>You need to be logged in to edit the collection.<br/><br/>Sincerely, your ProBlind Team",
  "warning_email_invalid": "This address is invalid.",
  "warning_email_disallowed": "This address violates our email address policy.",
  "warning_email_suspicious": "This address seems rather uncommon. Please check carefully if you want to submit it.",
  "mail_confirmation_subject": "Please confirm your email address",
  "mail_confirmation_text_plain": "Dear {{name}},\nOn the ProBlind Share Website (which you can visit at https://share.problind.org/ ) you provided {{address}} as your email address. Please visit this link to confirm it:\n{{url}}\n\nSincerely, your ProBlind Team\n\nPS: If this address was not provided by you, but by someone else without your consent, you do not need to do anything.",
  "mail_confirmation_text_html": "Dear {{name}},<br/>On the <a href=\"https://share.problind.org/\">ProBlind Share Website</a> you provided {{address}} as your email address. Please visit this link to confirm it: <a href=\"{{url}}\">{{url}}</a>.<br/><br/>Sincerely, your ProBlind Team<br/><br/><i>PS: If this address was not provided by you, but by someone else without your consent, you do not need to do anything.</i>",
  "message_mail_confirmation_unknown": "Unknown state during email confirmation. Please open the confirmation link again, or try to log in.",
  "message_mail_confirmation_success": "Your email address {{address}} has been confirmed. Thank You! You might need to log in again now.",
  "message_mail_confirmation_success_again": "Your email address {{address}} has been confirmed. Thank You!<br/><br/><i>PS: Your address already had been confirmed before. Additional confirmations have no effect.</i>",
  "message_mail_confirmation_error_code": "The email address could not be confirmed. The code is invalid. Please make sure that the link that has been sent to you was not altered in any way.",
  "message_mail_confirmation_error_other": "The email address could not be confirmed. The code was once valid, but something else went wrong.",
  "message_mail_confirmation_needed": "Your email address has not been confirmed yet.",
  "button_mail_confirmation_info": "Show more information",
  "header_mail_confirmation_intro": "Confirm email address",
  "label_mail_confirmation_intro": "We want to make sure that our mails reach you. Therefor we would like to send a link to the address '{{address}}' which you provided. By clicking that link, you confirm that you received the mail.",
  "button_mail_confirmation_send": "Send link to '{{address}}'",
  "button_mail_change": "Change address",
  "label_mail_confirmation_change": "If that email address is incorrect, or you would like to use another address, you can change it on the page '{{ navi_personal_data }}'.",
  "message_mail_confirmation_sent": "A confirmation link has been sent to '{{ navi_personal_data }}'. Please open the mail and click on the link.",
  "message_mail_confirmation_error": "The confirmation mail could not be delivered to '{{ navi_personal_data }}'. Please check the email address.",
  "label_clone_original": "This item is an original, not a clone of some other item.",
  "label_clone_from": "This item is a clone of <a target=\"_blank\" href=\"{{url}}\">{{title}}</a> ({{lang}}).",
  "label_clone_indirect": "This item is a direct clone of <a target=\"_blank\" href=\"{{url}}\">{{title}}</a> ({{lang}}), the common origin of both items is <a target=\"_blank\" href=\"{{originurl}}\">{{origintitle}}</a> ({{originlang}}).",
  "label_clones_of_this": "Clones of this item:",
  "label_no_changes": "No changes performed",
  "label_no_clones": "No clones available",
  "label_clones_info": "This section on clones is only visible to managers. Only \"direct descendants\" are listed, so no clones of clones.",
  "label_changes_info": "This listing of changes is only visible to managers.",
  "label_variants_of_this": "Other variants of this graphic:",
  "prefix_title": ", title: ",
  "postfix_origin": " (Origin graphic)",
  "postfix_parent": " (Direct parent graphic)",
  "label_graphic_id": "Graphic Id",
  "label_collection_id": "Collection Id",
  "label_password_strength_0": "extremely weak",
  "label_password_strength_1": "too weak",
  "label_password_strength_2": "okay",
  "label_password_strength_3": "strong",
  "label_password_strength_4": "very strong",
  "button_use_local_part": "Use \"{{name}}\"",
  "button_use_suggestion": "Use suggestion",
  "button_generate_texts": "Generate texts",
  "script_find_pairs_button_add_single": "New pair",
  "script_find_pairs_button_add_multiple": "New pairs with elements from the graphic",
  "script_find_pairs_label_pairs": "Pairs:",
  "script_find_pairs_error_pair_empty": "Pair {{oneBasedIndex}} is empty.",
  "script_find_pairs_error_pair_partially_empty": "One area of pair {{oneBasedIndex}} is empty.",
  "script_find_pairs_error_pair_same_area": "Pair {{oneBasedIndex}} contains the same area twice.",
  "script_find_pairs_error_area_overused": "These areas are used at least twice, possibly in different pairs: {{list}}.",
  "script_find_pairs_error_no_pairs": "You must add at least one pair.",
  "script_array_editor_button_up": "Move up",
  "script_array_editor_button_down": "Move down",
  "script_array_editor_button_delete": "Delete",
  "script_array_editor_button_add_element": "Add element",
  "script_area_ref_editor_button_select": "Choose {{element}} from the graphic",
  "script_area_ref_editor_button_show": "Show {{element}} on the graphic",
  "script_area_ref_editor_dropdown": "Choose {{element}} from list",
  "script_area_ref_editor_button_clear": "Clear {{element}}",
  "script_label_first_element": "first area",
  "script_label_second_element": "second area",
  "script_label_element_in_array": "element {{index}} of {{count}}",
  "script_find_groups_label_question": "Question for the group",
  "script_find_groups_button_add_single": "New group",
  "script_find_groups_button_add_and_select": "New group with elements from the graphic",
  "script_find_groups_label_groups": "Groups:",
  "script_find_groups_error_group_empty": "Group {{oneBasedIndex}} is empty.",
  "script_find_groups_error_group_partially_empty": "One area of group {{oneBasedIndex}} is empty.",
  "script_find_groups_error_group_same_area": "Group {{oneBasedIndex}} contains the same area multiple times.",
  "script_find_groups_error_area_overused": "These areas are used at least twice, possibly in different groups: {{list}}.",
  "script_find_groups_error_no_groups": "You must add at least one group.",
  "script_find_groups_button_show_all": "Show all areas",
  "script_follow_path_label_question": "Question for the path",
  "script_follow_path_button_add_single": "New path",
  "script_follow_path_button_add_and_select": "New path with elements from the graphic",
  "script_follow_path_label_groups": "Paths:",
  "script_follow_path_error_group_empty": "Path {{oneBasedIndex}} is empty.",
  "script_follow_path_error_group_partially_empty": "One area of path {{oneBasedIndex}} is empty.",
  "script_follow_path_error_group_same_area": "Path {{oneBasedIndex}} contains the same area multiple times.",
  "script_follow_path_error_area_overused": "These areas are used at least twice, possibly in different paths: {{list}}.",
  "script_follow_path_error_no_groups": "You must add at least one path.",
  "script_follow_path_button_show_all": "Show all areas",
  "script_find_object_error_object_empty": "Object {{oneBasedIndex}} is empty.",
  "script_find_object_error_no_object": "You must add at least one object.",
  "script_multiple_choice_button_add_single": "New question",
  "script_multiple_choice_button_add_choice": "New choice option",
  "script_multiple_choice_error_too_few_choices": "Question {{oneBasedIndex}} must have at least two choices.",
  "script_multiple_choice_error_empty_choices": "Question {{oneBasedIndex}} has at least one empty choice.",
  "script_multiple_choice_error_no_questions": "You must add at least one question.",
  "script_multiple_choice_label_question": "Question:",
  "script_multiple_choice_label_questions": "Questions:",
  "script_multiple_choice_label_choices": "Choices:",
  "toast_script_multiple_choice_no_simulation_info_message": "We currently don't support testing 'Multiple Choice' interactions inside the browser because the don't involve clicking on the graphic. Please test the Multiple Choice interactions on a Tactonom Reader..",
  "script_multiple_choice_label_correct_choice": "Correct choice:",
  "script_multiple_choice_label_answer": "Explanation for the correct choice (optional):",
  "header_script_type": "Interaction type: ",
  "button_script_help_label": "Help on interaction type '{{type}}'",
  "button_script_add_type": "Add '{{type}}' interaction",
  "button_script_help_label_all": "Help on the interaction types",
  "placeholder_interaction_name": "Please enter a unique name",
  "default_interaction_name": "(unnamed interaction #{{index}} of type '{{type}}')",
  "default_interaction_name_empty": "(unnamed interaction)",
  "label_warnings": "Warnings",
  "label_no_elements": "(no elements)",
  "label_empty_area": "(empty)",
  "label_area_not_found": "(area not found: '{{areaId}}')",
  "placeholder_question": "Find this object:",
  "placeholder_area": "No area selected",
  "placeholder_correct_choice": "Select the correct choice",
  "script_description_find_objects": "A set of questions about areas in the graphic. The user answers each question by clicking the corresponding area. Questions can be put together quickly by picking them from the graphic. By default the name of an area will be used. For example 'Rome' in a map of Europe. When the user then clicks the Rome area, he gets a positive feedback or an indication that this was the wrong choice.\n\nIt is also possible to type a more specific question such as 'What is the capital of Italy?'. Questions can be played in sequence or in random order. It also possible to limit the number of questions each time the interaction is called. A subset is picked automatically each time (this requires random ordering of questions and more than a minimum number or questions).",
  "script_description_find_pairs": "Challenges the user to find pairs of objects that belong together. This could be some tools together with the items for which they are used. The user learns how many pairs he needs to look for and can then point to an item which belongs to a pair. Next he points to the other item of the pair. This continues until he has discovered all pairs. To fastest way to put together an interaction is by selecting areas from the graphic. The first click will select the first item of a pair, the second click the second item of the first pair, the third click then begins with the second pair and selects its first item, the fourth click selects the second item of the second pair and so on...",
  "script_description_find_groups": "Asks the user to find a certain number of items that belong to the same category or group. For example, on an image of a farm, the user could be asked to point out all flowers, all trees or all buildings. To create this interaction, a question is needed that explains what kind of things we are looking for. Then all the matching areas can be added by selecting them from the graphic. The user can then point out all areas that belong to the group one by one. No particular order is required.",
  "script_description_follow_path": "Challenges the user to visit a number of areas in a specific sequence. This could be tracing a line from its first to its last point, showing the various steps of a process from first to last etc. The sequence starts with a question that describes the challenge. Each point which the user clicks is followed by a short acknowledgement (if correct) or information that this was the wrong area. The easiest way to put a path together is by clicking the different areas in the correct sequence in the graphic.",
  "script_description_multiple_choice": "This question type is not related to tactile areas within the graphic. Instead, the user is provided with multiple spoken options, from which one or more can be chosen. This type of interaction can not be tested inside the browser.",
  "toast_script_editor_popup_error_header": "Popup was blocked",
  "toast_script_editor_popup_error_message": "The Interactions-App should be shown in a new window or tab, but a pop-up-blocker prevented that. Please check the message underneath the browser's address bar.",
  "toast_script_editor_popup_success_header": "Interactions-App started",
  "toast_script_editor_popup_success_message": "The Interactions-App is displayed in a new tab or window.",
  "toast_script_editor_jwt_error_header": "Error in Interactions-App",
  "toast_script_editor_jwt_error_message": "The permissions for the Interactions-App could not be provided. Reason: {{reason}}",
  "title_updated_scripts": "Interactions updated",
  "message_updated_scripts": "The following interactions were based on outdated code versions and have been changed to `@tactonom/interactions/1.0.0`: {{ updatedScripts }}. Please check if they are still working as intended.",
  "message_script_language_adjusted": "The following interactions used languages which are not supported by the Reader and were changed to a supported language: {{ updatedScripts }}. Please check if they are still working as intended.",
  "label_read_only": "You do not have permission to edit or save this graphic.",
  "confirm_acting_on_behalf_title": "Confirmation needed to download file",
  "confirm_acting_on_behalf_message": "This graphic is restricted by copyright and may only be downloaded under the provisions of the Marrakesh Treaty. Are you currently acting on behalf of a blind person?",
  "toast_download_soon_info_header": "Download requested",
  "toast_download_soon_info_message": "Your download will start in a moment.",
  "toast_download_now_info_header": "Download started",
  "toast_download_now_info_message": "Your download was started right now.",
  "heading_stats_server_version": "Server version",
  "label_stats_server_version_versionSvgRepo": "Version of svg-repo",
  "label_stats_server_version_buildTimeSvgRepo": "svg-repo built at",
  "label_stats_server_version_buildHostSvgRepo": "svg-repo built on computer",
  "label_stats_server_version_execHostSvgRepo": "svg-repo executing on computer",
  "heading_stats_client_version": "Client version",
  "label_stats_client_version_lang": "Version of lang-js data",
  "label_translation_tables": "Braille translation tables:",
  "message_translation_table_not_found": "Table '{{table}}' does not exist.",
  "message_translation_table_unsupported_language": "Table '{{table}}' does not support the document language '{{unsupported}}', it only supports '{{supported}}'.",
  "message_translation_table_no_dis": "If no '.dis'-file is selected, 'unicode.dis' will be chosen automatically.",
  "message_translation_table_needed": "You must supply at least one translation table (usually a .ctb or .utb file).",
  "message_hyphenation_dictionary_encoding": "Hyphenation dictionary '{{table}}' might be incompatible with UTF-8 encoding.",
  "message_hyphenation_dictionary_not_found": "Hyphenation dictionary  '{{table}}' does not exist.",
  "message_display_table_not_found": "Display table '{{table}}' does not exist.",
  "placeholder_translation_tables": "If this field is empty, the standard tables for the document language are used.",
  "message_meta_error_empty": "Can't display user-friendly error message, because the response is empty.",
  "message_meta_error_hmtl": "Can't display user-friendly error message, because the response is a full HTML page.",
  "message_meta_error_body_used": "Can't display user-friendly error message, because the response body was used before. This is likely due to hot-updating the code during development.",
  "message_meta_error_no_message": "Can't display user-friendly error message, because JSON response did not contain a message. The raw JSON is: '{{json}}'.",
  "message_meta_error_unparsable": "Can't display user-friendly error message, because the input could not be parsed. See developer console for the raw input.",
  "message_meta_error_exception": "Can't display user-friendly error message, because parsing it caused another error.",
  "message_meta_suffix_status": " (Response status: {{statusReason}})",
  "message_meta_suffix_vnd": " (Standardized vnd.error response)",
  "button_add_table": "Add table",
  "button_from_list": "Choose from list",
  "header_display_tables": "Display tables",
  "header_hyphenation_dictionaries": "Hyphenation Dictionaries",
  "hint_translation_tables": "The tables which are entered above, separated with commas, are used. Below, you can search tables in a list, to add them above.",
  "label_default": "DEFAULT",
  "heading_tip_collections": "TIP-Collections",
  "heading_braille_test": "Braille",
  "heading_math_test": "Math",
  "label_braille_test_text": "Text to translate",
  "label_braille_test_filter": "Filter for translation tables (regular expression)",
  "label_braille_test_display_table": "Display table",
  "label_braille_test_results": "Results",
  "label_braille_test_table_filename": "Table filename",
  "label_braille_test_braille": "Braille",
  "label_braille_test_back_translation": "Back translation",
  "label_braille_test_back_translation_unescaped": "Back translation (unescaped)",
  "label_math_test_text": "Mathematical formula",
  "label_math_test_input_format": "Input format",
  "label_math_test_output_format": "Format",
  "label_math_test_results": "Results",
  "label_math_test_output": "Output",
  "label_math_test_output_language": "Output language",
  "label_math_test_speech_not_supported": "For the language {{language}}, written text cannot be converted to audio.",
  "label_math_test_language_not_supported": "For the language {{language}}, the written text to speak maths expressions cannot be generated.",
  "toast_designer_app_popup_error_header": "Popup was blocked",
  "toast_designer_app_popup_error_message": "The Designer-App should be shown in a new window or tab, but a pop-up-blocker prevented that. Please check the message underneath the browser's address bar.",
  "toast_designer_app_popup_success_header": "Designer-App started",
  "toast_designer_app_popup_success_message": "The Designer-App is displayed in a new tab or window.",
  "toast_designer_app_jwt_error_header": "Error in Designer-App",
  "toast_designer_app_jwt_error_message": "The permissions for the Designer-App could not be provided. Reason: {{reason}}",
  "designer_tool_select": "Select",
  "designer_tool_circle": "Circle",
  "designer_tool_ellipse": "Ellipse",
  "designer_tool_rect": "Rectangle",
  "designer_tool_text": "Tactile text (black)",
  "designer_tool_blue_text": "Visual text (blue)",
  "designer_tool_delete": "Delete",
  "designer_tool_resize": "Resize",
  "designer_tool_square": "Square",
  "designer_tool_line": "Line",
  "designer_tool_pencil": "Path, free hand",
  "designer_tool_path": "Path, bezier",
  "designer_tool_path_edit": "Edit path",
  "designer_tool_multi_select": "Multi-select",
  "designer_action_delete": "Delete",
  "designer_action_undo": "Undo: {{command}}",
  "designer_action_redo": "Redo: {{command}}",
  "designer_action_close_path": "Close path",
  "designer_action_clone": "Clone",
  "designer_action_move_top": "Move to the top",
  "designer_action_move_up": "Move up",
  "designer_action_move_down": "Move down",
  "designer_action_move_bottom": "Move to the bottom",
  "designer_action_group": "Group",
  "designer_action_ungroup": "Ungroup",
  "designer_action_selectparent": "Select parent group",
  "designer_action_unknown": "unknown action",
  "designer_label_mode": "Mode:",
  "button_edit_tactile_text": "Edit tactile text",
  "button_edit_visual_text": "Edit visual text",
  "button_edit_audio": "Edit audio",
  "warning_complex_structure_no_undo": "This text element has a complex inner structure that must be restructured while editing. If you apply this change, it cannot be fully undone.",
  "button_make_ascii_math": "Mark as AsciiMath",
  "role_admin": "Admin",
  "role_manager": "Manager",
  "role_tip": "Member of the Tactile Inclusion Project",
  "role_biotact": "Member of the project BioTact",
  "role_bio_tact": "Member of the project BioTact",
  "role_biotactmanager": "Manager of the project BioTact",
  "role_biotact_manager": "Manager of the project BioTact",
  "role_comment": "// In `PermissionCheck` roles are converted to camel case, but somewhere else they are still used without underscore. As a quick fix, lets define both keys.",
  "role_tipmanager": "Manager for the Tactile Inclusion Project",
  "role_tip_manager": "Manager for the Tactile Inclusion Project",
  "role_marrakeshmanager": "Manager for Marrakesh entitlement", 
  "role_marrakesh_manager": "Manager for Marrakesh entitlement",
  "role_marrakeshbeneficiary": "Beneficiary of the Marrakesh Treaty",
  "role_marrakesh_beneficiary": "Beneficiary of the Marrakesh Treaty",
  "role_loggedin": "Logged in user",
  "role_logged_in": "Logged in user",
  "label_roles": "Roles",
  "label_current_hidden": "Hidden graphics",
  "label_graphics_count": "Graphics",
  "mail_audio_braille_subject": "Audio-Braille for the text \"{{text}}\"",
  "mail_audio_braille_text_plain": "Dear {{name}},\nThe attachment contains the text \"{{text}}\" as Audio-Braille.\n\nSincerely, your Tactonom Team",
  "mail_audio_braille_text_html": "Dear {{name}},<br/>The attachment contains the text \"{{text}}\" as Audio-Braille.<br/><br/>Sincerely, your Tactonom Team",
  "heading_language_support": "Languages",
  "header_language_support_language": "Language",
  "header_language_support_language_tag": "Language tag",
  "header_language_support_service_google_cloud_text_to_speech": "Google TTS",
  "header_language_support_service_liblouis_braille_translator": "Liblouis Braille",
  "header_language_support_service_svg_repo_user_interface": "Share Website",
  "header_language_support_service_svg_repo_graphics": "Graphic Language",
  "header_language_support_service_amazon_polly": "Amazon Polly TTS",
  "header_language_support_service_amazon_translate": "Amazon Translate",
  "header_language_support_service_tactonom_reader_canned_text_system_message_service": "Reader Menu and Interactions",
  "header_language_support_service_speech_rule_engine": "SRE (speak math formulas)",
  "label_yes": "Yes",
  "label_no": "No",
  "filename_svg_template": "{{title}} (new graphic template).svg",
  "compare_display_mode_new": "New",
  "compare_display_mode_old": "Old",
  "compare_display_mode_edit": "Edit",
  "compare_display_mode_swell": "Swell-Print",
  "compare_description": "On this page, you can compare how a graphic looked before and after the time the braille font was changed. For graphics which were added after that, this view does not work.",
  "label_step": "Step {{number}}",
  "label_chosen_file": "Chosen file:",
  "label_chosen_file_empty": "None",
  "button_upload_reset": "New upload",
  "label_no_report": "No validation report available.",
  "error_template_title_required": "The graphic template needs a title",
  "error_template_description_required": "The graphic template needs a description",
  "error_template_language_required": "You must chose a language",
  "error_template_license_required": "You must chose a license, or activate the copyright exception",
  "error_template_paper_size_required": "Please chose a paper format. When in doubt, chose A3.",
  "button_import_image": "Insert image into graphic",
  "button_import_image_with_markers": "Insert image with markers into graphic",
  "toast_import_image_error_text": "Image could not be inserted. Reason: {{reason}}",
  "button_import_image_progress": "Optimizing: {{progress}}% ...",
  "mail_new_commission_subject": "New {{project}}-Graphic commissioned by {{requesterName}}",
  "mail_new_commission_text_plain": "Hello {{managerName}},\nThe {{project}} user {{requesterName}} commissioned the graphic \"{{graphicTitle}}\".\n\nThis does not imply that the contents are ready to be processed yet.\n\nYou can view the graphic at: {{url}}",
  "mail_new_commission_text_html": "Hello {{managerName}},<br/>The {{project}} user {{requesterName}}commissioned the graphic <a href=\"{{url}}\">{{graphicTitle}}</a>.<br/><br/>This does not imply that the contents are ready to be processed yet.",
  "message_commission_done": "All base data for the new {{project}} graphic has been submitted. The designer-app has opened in a new tab, where you can upload images and add audio texts.",
  "button_mode_default": "All features",
  "button_mode_photo": "Image",
  "button_mode_interactive": "Audio",
  "button_mode_tactile": "Tactile",
  "button_mode_select_any": "Select anything",
  "button_mode_all": "All features",
  "button_mode_draw": "Draw (Beta)",
  "button_mode_audio": "Audio",
  "label_tool": "Tool:",
  "label_action": "Action:",
  "message_single_area": "Select a single element to edit title and description.",
  "button_open_in_designer_app": "Open in Designer-App",
  "message_commission_buttons": "Choose 'Download template' if you want to use an offline program (like Inkscape) to draw you own graphic. To commission a new graphic using an image template, choose 'Open in Designer-App'.",
  "toast_draw_beta_header": "Beta version",
  "toast_draw_beta_message": "The drawing mode is experimental and will get more and more features.",
  "error_user_does_not_exists": "The user does not exist.",
  "error_self_invite": "You can't invite yourself.",
  "error_owner_invite": "You can't invite someone to their own graphic.",
  "error_user_already_invited": "This user is already invited to this graphic.",
  "error_role_does_not_exist": "The given role does not exist.",
  "error_invite_does_not_exist": "The given invitation does not exist",
  "error_invite_other_graphic": "The invitation belongs to another graphic.",
  "error_invite_missing_account": "You must include either accountId or accountEmail.",
  "error_invite_overspecified_account": "You must not include both accountId and accountEmail.",
  "error_api_not_found": "The API {{url}} was not found, or the API did not find a requested resource.",
  "error_invalid_graphic_id": "The graphic id '{{gid}}' is generally invalid, irrespective of the (non-)existence of a graphic with that id.",
  "error_invalid_filename": "The file name '{{filename}}' is invalid.",
  "error_message_untranslated": "{{error}}",
  "label_use_full_width": "Use full screen width",
  "label_visible_columns": "Visible columns",
  "button_show_all": "show all",
  "button_hide_all": "hide all",
  "account_status_needs_confirmation": "email unconfirmed",
  "account_status_active": "activated",
  "account_status_invalid": "(state invalid)",
  "account_status_deleted": "deleted",
  "label_tts_usage": "TTS usage",
  "label_unlimited": "unlimited",
  "button_resend_confirmation_mail": "Re-send confirmation mail",
  "toast_admin_success_header": "Success",
  "toast_admin_success_message": "The admin action succeeded.",
  "toast_admin_error_header": "Error",
  "toast_admin_error_message": "There was an error with this admin action.",
  "toast_general_success_header": "Success",
  "toast_general_success_message": "The action succeeded.",
  "toast_general_error_header": "Error",
  "toast_general_error_message": "There was an error.",
  "label_marrakesh_reason": "Reason to change the users Marrakesh status (required to make a change):",
  "button_save_changes": "Save changes",
  "label_id": "id",
  "label_data_not_loaded": "Data not yet loaded",
  "aria_item_by": "by",
  "aria_item_description": "description",
  "page_accessibility": "Accessibility test",
  "title_select_markers": "Select markers",
  "label_select_markers": "Please click to select all four markers in the image. You can move the markers by dragging them.",
  "toast_image_is_processing_header": "Image is being processed",
  "toast_image_is_processing_preview_message": "A small preview is being generated...",
  "toast_image_is_processing_full_message": "Preview is done. The full-sized image is being generated. This may take a while...",
  "link_forgot_password": "Forgot your password?",
  "title_reset_password": "Reset password",
  "message_reset_password": "If you don't remember your password, you can reset it here. To proceed, please enter your email address that you used to register on Share. We will send you a link, so you can perform the actual password change.",
  "button_reset_password_request_link": "Send link",
  "button_reset_password_perform": "Apply new password",
  "label_new_password": "New password",
  "toast_reset_password_error_message": "Could not send the confirmation link. Reason: {{reason}}",
  "message_reset_password_mail_sent": "We just sent a confirmation mail to the given email address, provided that an account exists with that email address. If you do not receive that mail within a few minutes, please check the mail address that you entered. If in doubt, search your mail inbox for the confirmation mail from Share that you got earlier when you registered your account.",
  "mail_reset_password_subject": "Reset your password for ProBlind Share",
  "mail_reset_password_text_plain": "Dear {{name}},\nOn the ProBlind Share Website (which you can visit at https://share.problind.org/ ) you requested to reset your password, and provided {{address}} as your email address. Please visit this link to choose a new password:\n{{url}}\n\nSincerely, your ProBlind Team\n\nPS: If this address was not provided by you, but by someone else without your consent, you do not need to do anything.",
  "mail_reset_password_text_html": "Dear {{name}},<br/>On the <a href=\"https://share.problind.org/\">ProBlind Share Website</a> you requested to reset your password, and provided {{address}} as your email address. Please visit this link to choose a new password: <a href=\"{{url}}\">{{url}}</a>.<br/><br/>Sincerely, your ProBlind Team<br/><br/><i>PS: If this address was not provided by you, but by someone else without your consent, you do not need to do anything.</i>",
  "success_message_reset_password_success": "Your password was changed successfully. You can now use it to log in.",
  "message_reset_password_perform": "To reset your password, please enter your desired new password below. After submitting this form, you should be able to log in with your email address and your new password.",
  "error_message_reset_password_error": "Your password cannot be changed at the moment. Please make sure that you used the full, unmodified link from the confirmation mail. If the code is too old and has expired, you have to request a new code.",
  "error_missing_parameter": "One or more required parameters are missing.",
  "header_events_revision_file": "Download",
  "header_events_revision": "Base → revision",
  "header_events_revision_based_on": "Based on",
  "link_download_revision_file": "download",
  "error_revision_file_not_found": "The file for this revision could not be found.",
  "label_revision_current": "(current)",
  "heading_revision_conflict": "Revision conflict",
  "error_save_outdated_graphic": "The graphic that you tried to save is based on the outdated revision {{uploadedRevision}}. The most current revision is {{latestRevision}}.",
  "error_save_outdated_graphic_previous": "The graphic that you tried to save is based on the outdated revision {{uploadedRevision}}. The most current revision is {{latestRevision}}. An upload based on the previous revision {{previousRevision}} would also be accepted.",
  "error_save_outdated_graphic_none": "The graphic that you tried to save has no revision information. Therefore it's impossible to check if it is based on the latest revision {{latestRevision}}.",
  "special_tag_autodelete_title": "AUTODELETE",
  "special_tag_autodelete_description": "The graphic will be deleted automatically 12 hours after its creation. Useful for tests and demos.",
  "special_tag_tip_title": "Tip",
  "special_tag_tip_description": "Tactile Inclusion Project",
  "special_tag_tip_clone_title": "Tip-Clone",
  "special_tag_tip_clone_description": "Graphic is based on an original from the Tactile Inclusion Project",
  "special_tag_biotact_title": "BioTact",
  "special_tag_biotact_description": "BioTact Project",
  "special_tag_outdated_patterns_title": "Outdated-Patterns",
  "special_tag_outdated_patterns_description": "Graphic contains at least one TG-Outdated pattern that should be replaced.",
  "special_tag_model_attachments_title": "3d-Model",
  "special_tag_model_attachments_description": "3d models, which are needed for this graphic, are attached",
  "special_tag_line_tracing_title": "Line-Tracing",
  "special_tag_line_tracing_description": "The graphic contains lines which can be traced",
  "special_tag_interactions_title": "Interaction",
  "special_tag_interactions_description": "The graphic contains one or more interactions",
  "special_tag_translated_by_openai_title": "Openai-Translation",
  "special_tag_translated_by_openai_description": "The LLM ChatGPT by OpenAI was used to translate this clone",
  "special_tag_translated_by_gemini_title": "Gemini-Translation",
  "special_tag_translated_by_gemini_description": "The LLM Gemini by Goolge was used to translate this clone",
  "special_tag_batch_translation_title": "Batch-Translation",
  "special_tag_batch_translation_description": "Translated without checking the result manually",
  "special_tag_informal_address_title": "Sie-Into-Du",
  "special_tag_informal_address_description": "Formal address was automatically rewritten into informal address. Please check the result and then delete this tag.",
  "special_tag_magic_numbers_title": "Magic-Numbers",
  "special_tag_magic_numbers_description": "Checks automatically if the Magic Braille Numbers were placed correctly to show the correct result of a computation.",
  "special_tag_math_format_title": "Math-Format",
  "special_tag_math_format_description": "Contains formulas that were written using AsciiMath, LaTeX or similar syntax",
  "special_tag_magic_measurement_title": "Magic-Measure",
  "special_tag_magic_measurement_description": "For measurements with the Magic Math Tools",
  "page_show_collection": "Show collection",
  "page_show_collection_title": "Show collection \"{{title}}\"",
  "message_collection_load_error": "The collection cannot be shown due to an error.",
  "toast_add_graphic_to_collection_success_header": "Added graphic",
  "toast_add_graphic_to_collection_success_message": "The graphic '{{graphic}}' was successfully added to the collection '{{collection}}'.",
  "toast_add_graphic_to_collection_error_header": "Could not add graphic",
  "toast_add_graphic_to_collection_error_message": "There was an error while adding the graphic '{{graphic}}' to the collection '{{collection}}': {{reason}}",
  "warning_already_in_collection": "The item is already contained in the collection.",
  "menu_group_add_graphic_to_collection": "Add to collection...",
  "menu_group_other_users_collections": "Other user's collections",
  "menu_now_own_collections": "(there are no own collections)",
  "button_collection_sort_up": "Move up",
  "button_collection_sort_down": "Move down",
  "button_collection_delete": "Remove from collection",
  "label_no_graphic_description": "(Graphic has no Description)",
  "label_no_collection_description": "(Collection has no Description)",
  "toast_collection_change_order_error_header": "Could not change the order",
  "toast_collection_remove_item_error_header": "Could not remove item from collection",
  "button_collection_add_child": "Add element to collection",
  "header_create_sub_collection": "Create subordinate collection",
  "toast_create_collection_success_header": "Collection created",
  "toast_create_collection_success_message": "You can now add content to the new collection.",
  "toast_create_collection_error_header": "Could not create collection",
  "toast_create_collection_error_message": "While creating the new collection, an error occurred: {{reason}}",
  "label_empty_collection": "(Collections does not contain elements)",
  "label_short_empty_collection": "(empty collection)",
  "label_short_hidden_graphic": "(hidden graphic)",
  "label_short_hidden_collection": "(hidden collection)",
  "label_short_missing_item": "(missing item)",
  "label_explain_add_graphic_to_collection": "To add an existing graphic to a collection, please go to the graphic list, find the graphic, and perform a right click on it. Then you can select this collection to add it to. Later, it will be possible to search and add graphics from here.",
  "tab_add_text_element_to_collection": "Text element",
  "label_text_element_type": "Kind of text element",
  "text_type_paragraph": "Paragraph",
  "text_type_h1": "Heading level 1 (largest)",
  "text_type_h2": "Heading level 2",
  "text_type_h3": "Heading level 3",
  "text_type_h4": "Heading level 4",
  "text_type_h5": "Heading level 5 (smallest)",
  "button_create_and_add": "Create and add",
  "button_add_collection_member": "Add",
  "button_add_collection_members_count": "Add {{count}} item(s)",
  "toast_add_items_to_collection_success_header": "Adding successful",
  "toast_add_items_to_collection_success_message": "All {{successCount}} item(s) were added.",
  "toast_add_items_to_collection_warn_header": "Partial success",
  "toast_add_items_to_collection_warn_message": "Only {{successCount}} of the item(s) could be added. The other {{errorCount}} item(s) failed.",
  "toast_add_items_to_collection_error_header": "Adding failed",
  "toast_add_items_to_collection_error_message": "None of the {{errorCount}} item(s) could be added.",
  "label_position_to_add": "position:",
  "label_position_top": "At the start",
  "label_position_bottom": "At the end",
  "label_position_between": "Between '{{above}}' and '{{below}}'",
  "label_position_empty": "Into the empty collection",
  "title_collection_add_child": "Add element to collection '{{title}}'",
  "button_text_item_edit": "Edit text-element",
  "toast_create_text_item_error_header": "Could not create text element",
  "toast_create_text_item_error_message": "While creating the new text element, an error occurred: {{reason}}",
  "toast_edit_text_item_error_header": "Could not edit text element",
  "toast_edit_text_item_error_message": "While saving the text element, an error occurred: {{reason}}",
  "error_invalid_parameter": "One or more request parameters are invalid.",
  "button_collapse_all": "Collapse all",
  "button_expand_all": "Expand all",
  "label_collection_display_mode": "Collection layout",
  "collection_display_mode_grid": "Grid",
  "collection_display_mode_list": "List",
  "collection_display_mode_tree": "Tree",
  "label_collection_placeholder": "(collection)",
  "message_collection_edit_tree": "The contents of a collection can only be edited in the 'tree' layout at the moment.",
  "message_collection_paper_size": "Filtering by paper size does not affect which collections are shown.",
  "message_collection_duplicate_order_key": "The ordering of this collection is broken. Editing the sort order may not work reliably or not at all. We are working on a solution.",
  "label_collection_action_multiple": "Apply action to multiple items:",
  "button_collection_action_multiple": "Apply now",
  "label_collection_action_multiple_action_hide": "hide",
  "label_collection_action_multiple_action_publish": "publish",
  "label_collection_action_multiple_action_deactivate": "deactivate",
  "label_collection_action_multiple_action_add_tag": "add tag",
  "label_collection_action_multiple_action_remove_tag": "remove rag",
  "label_collection_action_multiple_action_download_png": "download archive with PNG images",
  "label_collection_action_multiple_action_rewrite_informal_address": "Rewrite 'Sie' into 'Du'",
  "label_collection_action_multiple_action_check_ascii_math": "Check AsciiMath character set",
  "label_collection_action_multiple_target_graphics_direct": "All {{count}} directly contained graphics",
  "label_collection_action_multiple_target_graphics_recursive": "All {{count}} recursively contained graphics",
  "label_collection_action_multiple_target_items_direct": "All {{count}} directly contained graphics and collections",
  "label_collection_action_multiple_target_items_recursive": "All {{count}} recursively contained graphics and collections",
  "error_png_too_large": "The graphic contains an embedded PNG image which could not be processed. It's likely due to the image having a resolution that is too high, respectively too many pixels. The image is embedded in the element {{element}}.",
  "error_during_validation_html": "<h1>Error while validating the graphic</h1><div class=\"alert alert-danger\" role=\"alert\">{{error}}</div>",
  "error_parser_with_location": "Parser error in uploaded file, line {{line}}, column {{column}}: {{error}}",
  "bridge_exception_message_wrapper": "BridgeException with much too long error message ({{length}} characters). Element: '{{element}}'. Error code: '{{code}}'. Shortened message: '{{error}}'.",
  "error_at_element": "Error relating to the element {{element}}: {{error}}. Source of the element: {{elementsource}}",
  "message_splits_screen_possible": "Hint: if you enlarge your browser window, the graphic and the interactions can be shown side by side.",
  "toast_save_failed_unnamed_interactions_message": "At least one interaction has no name, or multiple names are the same. You have to give each interaction a unique name, so that users of the graphic can select an interaction.",
  "button_change_interaction_order": "Change order",
  "header_change_interaction_order": "Change the order of interactions",
  "confirm_header": "Please confirm",
  "confirm_message": "Do you really want to do this?",
  "confirm_reject": "No",
  "confirm_accept": "Yes",
  "confirm_delete_header": "Confirm deletion",
  "confirm_delete_message": "Do you really want to delete this item?",
  "confirm_delete_reject": "Keep",
  "confirm_delete_accept": "Delete",
  "confirm_delete_interaction_header": "Really delete interaction?",
  "confirm_delete_interaction_message": "Do you really want to delete the interaction '{{item}}'? This cannot be undone.",
  "confirm_discard_unsaved_changes_header": "Unsaved changes",
  "confirm_discard_unsaved_changes_message": "You are about to leave this page. Your unsaved changes will be lost.",
  "confirm_discard_unsaved_changes_graphic_message": "You are about to leave this page. Your unsaved changes to the graphic will be lost.",
  "confirm_discard_unsaved_changes_collection_message": "You are about to leave this page. Your unsaved changes to the collection will be lost.",
  "confirm_discard_unsaved_changes_interaction_message": "You are about to leave this page. Your unsaved changes to the interactions will be lost.",
  "confirm_discard_unsaved_changes_accept": "Discard changes",
  "confirm_discard_unsaved_changes_reject": "Stay on page",
  "message_permission_check_loading": "Permission is being checked...",
  "message_permission_check_needs": "Needs the role: {{role}}. ",
  "message_permission_check_needs_one_of": "Needs one of the following roles: {{roles}}. ",
  "message_permission_check_needs_all_of": "Needs all of the following roles: {{roles}}. ",
  "message_permission_check_failed": "Not permitted. ",
  "checkbox_highlight_permission_checks": "Highlight needed permissions with colors",
  "heading_ui_translations": "UI translations",
  "heading_ui_errors": "Errors",
  "message_feature_pending_changes": "This feature is not available, because we are currently re-thinking how it should work internally.",
  "label_metrics_lifetime_download_count_web": "Web downloads (total)",
  "label_metrics_lifetime_download_count_reader": "Reader downloads (total)",
  "label_metrics_three_months_download_count_web": "Web downloads (last 3 months)",
  "label_metrics_three_months_download_count_reader": "Reader downloads (last 3 months)",
  "label_metrics_clone_rank": "Clone-Rank",
  "label_metrics_rank_within_language": "Rank within language",
  "label_show_more": "show more",
  "label_all_tags_needed": "all tags must match",
  "postfix_extern": " (extern)",
  "label_errors_shorten_stack_traces": "Shorten stack traces (remove framework code)",
  "label_errors_poll_automatically": "Poll for errors automatically",
  "button_errors_clear": "Clear log",
  "button_errors_reload": "Reload",
  "label_errors_skipped_lines": "(Skipped {{count}} lines of framework code.)",
  "label_errors_skipped_lines_part": "lines of framework code",
  "toast_fetch_error_log_error_header": "Could not fetch error log",
  "message_end_of_list" : "End of list has been reached.",
  "label_locale_input_language": "Language:",
  "label_locale_input_voice": "Voice:",
  "label_locale_input_brailletables": "Braille tables:",
  "label_locale_input_mathformat": "Math input format:",
  "label_braille_preview": "Braille preview:",
  "label_inherited": "Inherited: ",
  "label_inherited_nothing": "nothing",
  "label_use_swellpaper_version": "Use swell-paper conversion as extra preparation step before using braille-printer conversion",
  "message_text_too_complex": "The inner structure of the selected text-element is too complex for editing. Please use Inkscape or a similar Software.",
  "error_google_voice_replaced": "The voice {{voice}} is no longer supported by Google, thus no new audio files can be created for that voice.",
  "label_collect_messages": "Collect messages (deactivate to avoid out-of-memory when updating all graphics at once)",
  "label_change_owner": "Change owner",
  "button_change_owner": "Change owner",
  "confirm_change_owner_header": "Change owner",
  "confirm_change_owner_message": "Shall {{owner}} really become the new owner of this graphic?",
  "placeholder_dropdown_no_options": "(no options available)",
  "placeholder_dropdown_nothing_selected": "(nothing selected)",
  "landing_page_label_stats": "There are already {{ graphic_count }} free (audio-)tactile graphics in {{ language_count }} languages!",
  "landing_page_label_stats_graphic_fallback": "many",
  "landing_page_label_stats_language_fallback": "several",
  "landing_page_label_become_a_part": "Become a part of the ProBlind Community: Use graphics by others and share your own ones with blind people all over the world.",
  "landing_page_heading_get_started": "Assorted manuals",
  "landing_page_label_get_started_link_text_1": "Create tactile graphics",
  "landing_page_label_get_started_link_url_1": "https://www.problind.org/wp-content/uploads/2022/08/Quick-guide-creating-a-tactile-graphic.pdf",
  "landing_page_label_get_started_link_tags_1": "PDF",
  "landing_page_label_get_started_link_text_2": "Graphics program Inkscape",
  "landing_page_label_get_started_link_url_2": "https://www.problind.org/wp-content/uploads/2022/08/Quick-guide-graphic-software-Inkscape.pdf",
  "landing_page_label_get_started_link_tags_2": "PDF",
  "landing_page_label_get_started_link_text_3": "Make existing graphics tactile",
  "landing_page_label_get_started_link_url_3": "https://www.problind.org/wp-content/uploads/2022/08/Quick-guide-Transform-existing-graphics-into-audio-tactile-graphics.pdf",
  "landing_page_label_get_started_link_tags_3": "PDF",
  "landing_page_label_get_started_link_text_4": "You can translate graphics",
  "landing_page_label_get_started_link_url_4": "https://www.problind.org/wp-content/uploads/2022/08/Quick-Guide-translation-tool.pdf",
  "landing_page_label_get_started_link_tags_4": "PDF",
  "landing_page_label_get_started_link_text_5": "Download Graphics",
  "landing_page_label_get_started_link_url_5": "https://www.problind.org/en/donwloading-graphics/",
  "landing_page_label_get_started_link_tags_5": "",
  "landing_page_label_get_started_link_text_6": "Using Tags: Filter by Topics and Keywords",
  "landing_page_label_get_started_link_url_6": "https://www.problind.org/en/using-tags/",
  "landing_page_label_get_started_link_tags_6": "",
  "landing_page_label_get_started_link_text_7": "Uploading sounds",
  "landing_page_label_get_started_link_url_7": "https://www.problind.org/en/uploading-sounds/",
  "landing_page_label_get_started_link_tags_7": "",
  "landing_page_label_get_started_link_text_8": "Registration and Login",
  "landing_page_label_get_started_link_url_8": "https://www.problind.org/en/registration-login/",
  "landing_page_label_get_started_link_tags_8": "",
  "landing_page_label_get_started_link_text_9": "Interactions App: Add Questions and Answers to Your Graphic",
  "landing_page_label_get_started_link_url_9": "https://www.problind.org/en/interactions-app/",
  "landing_page_label_get_started_link_tags_9": "",
  "landing_page_label_get_started_link_text_10": "User interface of the graphic editor",
  "landing_page_label_get_started_link_url_10": "https://www.problind.org/en/graphic-editor/",
  "landing_page_label_get_started_link_tags_10": "",
  "landing_page_label_get_started_link_text_11": "Interactions-App",
  "landing_page_label_get_started_link_url_11": "",
  "landing_page_label_get_started_link_tags_11": "",
  "landing_page_label_get_started_link_text_12": "Designer-App",
  "landing_page_label_get_started_link_url_12": "",
  "landing_page_label_get_started_link_tags_12": "",
  "landing_page_label_get_started_link_text_13": "Downloading an printing graphics on swell paper",
  "landing_page_label_get_started_link_url_13": "",
  "landing_page_label_get_started_link_tags_13": "",
  "landing_page_label_get_started_link_text_14": "Downloading an printing graphics with a braille embosser",
  "landing_page_label_get_started_link_url_14": "",
  "landing_page_label_get_started_link_tags_14": "",
  "landing_page_label_get_started_link_text_15": "Signing up",
  "landing_page_label_get_started_link_url_15": "",
  "landing_page_label_get_started_link_tags_15": "",
  "landing_page_label_get_started_link_text_16": "Special access for blind users",
  "landing_page_label_get_started_link_url_16": "",
  "landing_page_label_get_started_link_tags_16": "",
  "landing_page_tag_get_started_new": "new",
  "landing_page_tag_get_started_pdf": "PDF",
  "landing_page_heading_discover": "Discover graphics",
  "landing_page_discover_title_my_graphics": "My graphics",
  "landing_page_discover_subtitle_my_graphics": "Graphics owned by you",
  "landing_page_discover_title_new_graphics": "Newest graphics",
  "landing_page_discover_subtitle_new_graphics": "Graphics which where created or modified recently",
  "landing_page_discover_title_popular_graphics": "Popular graphics",
  "landing_page_discover_subtitle_popular_graphics": "Graphics which have been used a lot recently",
  "landing_page_discover_title_common_tags": "Commonly used tags",
  "landing_page_discover_subtitle_common_tags": "With tags you can filter the graphics list for keywords",
  "landing_page_discover_placeholder_no_own_graphics": "When you create your first own graphics, they will be listed here.",
  "landing_page_discover_placeholder_not_logged_in": "Log in so that your own graphics can be shown here.",
  "landing_page_heading_graphic_search": "Graphic search:",
  "landing_page_placeholder_graphic_search_text": "Enter search terms",
  "landing_page_link_to_details_search": "Advanced search",
  "landing_page_heading_videos": "Instruction videos",
  "landing_page_heading_more_videos": "More videos about graphic creation and editing",
  "landing_page_label_play_video": "Play Video",
  "landing_page_button_slider_left": "scroll forward",
  "landing_page_button_slider_right": "scroll back",
  "landing_page_video_title_1": "Tactonom Designer App - Step by Step",
  "landing_page_video_super_title_1": "Designer-App",
  "landing_page_video_description_1": "In this video you will learn how to easily add audio information to existing graphics with the Designer App.",
  "landing_page_video_id_1": "RUCQfO8ENHM",
  "landing_page_video_link_text_1": "",
  "landing_page_video_link_url_1": "",
  "landing_page_video_title_2": "How to add the Interaction 'Find Objects'",
  "landing_page_video_super_title_2": "Interactions-App",
  "landing_page_video_description_2": "Learn how to create your first 'Find Objects' Interaction. It is especially suitable for question-and-answer tasks. In this mode every question is answered by selecting the correct object.",
  "landing_page_video_id_2": "A1H1NwW6bs0",
  "landing_page_video_link_text_2": "",
  "landing_page_video_link_url_2": "",
  "landing_page_video_title_3": "Create tactile graphics and upload them on Share",
  "landing_page_video_super_title_3": "Put your heading here",
  "landing_page_video_description_3": "Learn how easy it is to create your own tactile graphic and how to upload it on the ProBlind database “Share”. All you need is an account on share.problind.org and the graphic software Inkscape. Both is for free.",
  "landing_page_video_id_3": "768890254",
  "landing_page_video_link_text_3": "",
  "landing_page_video_link_url_3": "",
  "landing_page_heading_news": "New features on Share",
  "landing_page_label_news_date_1": "2025-05-13",
  "landing_page_label_news_title_1": "Attach 3d-models to graphics",
  "landing_page_label_news_description_1": "On graphics that should be used together with 3d models, STL files can now be attached. On the graphic's page, there is now a new tab 'attachment' where they can be uploaded and downloaded. Such graphics automatically get the tag '3d model'.",
  "landing_page_label_news_date_2": "2025-04-28",
  "landing_page_label_news_title_2": "Search for multiple tags at once",
  "landing_page_label_news_description_2": "Normally, if you select multiple tags while browsing, the results will start with items that match all tags, and then continue with items that only match some of the tags. With the new option 'all tags must match', only those results are shown that have all the selected tags.",
  "landing_page_label_news_date_3": "2025-04-29",
  "landing_page_label_news_title_3": "New landing page for a better overview",
  "landing_page_label_news_description_3": "From now on, this landing page gives you an overview of what you can do on Share. Manuals, tips, the newest and most popular graphics, as well as a list of tags - everything in one place.",
  "landing_page_label_news_date_4": "2025-04-27",
  "landing_page_label_news_title_4": "Print on 11 × 11.5 inch paper",
  "landing_page_label_news_description_4": "You can now chose the 11 × 11.5 inch paper format when printing or embossing graphics.",
  "landing_page_label_news_date_5": "2025-04-13",
  "landing_page_label_news_title_5": "List of graphics takes less time to load",
  "landing_page_label_news_description_5": "Due to the large number of graphics, it used to take a while to load the list. For recurring visitors on Share, the list will load almost instantaneous now.",
  "landing_page_label_news_date_6": "2025-05-30",
  "landing_page_label_news_title_6": "Support for ViewPlus Braille printers und paper formats",
  "landing_page_label_news_description_6": "When downloading graphics for Brailler printers, you can now select from ViewPlus. And we added an option for the 12 Inch paper format from IndexBraille, irrespective of the chosen printer technology or brand.",
  "landing_page_label_news_date_7": "2025-06-04",
  "landing_page_label_news_title_7": "Enhanced navigation to avoid overwriting changes and losing work",
  "landing_page_label_news_description_7": "When you open the Designer-App or Interactions-App from Share, they are no longer opened in a new tab. This should make it less likely to make simultaneous changes to the same graphic, which would overwrite each other. Should there be conflicting edits anyway, these are now detected and you get to make an active choice about which edit to keep.",
  "landing_page_label_news_date_8": "2025-07-29",
  "landing_page_label_news_title_8": "Migration to a new, more powerful server",
  "landing_page_label_news_description_8": "Share is now running on a new server with more storage, RAM and CPU power. This will speed up all your tasks and actions on Share.",
  "landing_page_label_news_date_9": "2025-07-30",
  "landing_page_label_news_title_9": "Multilingual graphic search",
  "landing_page_label_news_description_9": "You speak multiple languages? If you have configured your languages appropriately in your browser's settings, you can filter graphics on Share not only for one or all languages, but for all the languages you speak at once. In the language selection, there's a new item directly after 'all languages'.",
  "landing_page_label_news_date_10": "2025-08-19",
  "landing_page_label_news_title_10": "Collections can be tagged now",
  "landing_page_label_news_description_10": "From now on, tags can be added to collections as well, so they can be filtered by topic more easily. And within the collection view, the tags on the collection's content are shown more consitently.",
  "landing_page_label_news_date_11": "2025-09-08",
  "landing_page_label_news_title_11": "Many improvements for searching and filtering",
  "landing_page_label_news_description_11": "Now you can also filter graphics and collections for *not* having a specific tag. To do this, just hold the Shift-Key while clicking the tag in on the 'Browse' page. Also related to tags: every graphic with at least one interaction now is tagged with 'Interaction' automatically. And search terms are now applied to the descriptions of graphics and collections. In the result list, title matches are always listed before description matches.",
  "landing_page_label_news_date_12": "2025-09-11",
  "landing_page_label_news_title_12": "Enhanced navigation between graphics and collections",
  "landing_page_label_news_description_12": "Here we improved multiple things as well: When you view a graphic or description, the top bar displays the name of the owner, which links to more content by the same user. Collections which have a single super-collections show an additional link to that as well. And large collections - such as the recently added TIP maths collections - are now loaded more quickly.",
  "landing_page_label_news_date_13": "2025-09-15",
  "landing_page_label_news_title_13": "Adjust braille translations before printing",
  "landing_page_label_news_description_13": "When you download a graphic for printing or embossing, you can now choose how the included texts are translated into braille. For most languages, you can choose between the graphics's default, or a 6-dot or 8-dot version. If you have a special wish for a specific LibLouis table, you can even select that.",
  "landing_page_label_news_date_14": "2025-10-23",
  "landing_page_label_news_title_14": "Formulas as configurable braille output and spoken text",
  "landing_page_label_news_description_14": "In many mathematical graphics - e.g. most graphics from the 'TIP' project - formulas are marked as AsciiMath. For those texts, a spoken version of the formula is generated automatically. When downloading there graphics for printing, you can also choose if and how formulas are converted into braille. In the future, we will offer even more mathematical braille systems here.",
  "landing_page_label_news_date_15": "2025-10-16",
  "landing_page_label_news_title_15": "Herunterladen aller Grafiken einer Sammlung",
  "landing_page_label_news_description_15": "When you view a collection, you will now find a download button at the end of the page. With that, you can download all (directly) contained graphics of the collection at once. You will get a zip archive with one printable file per graphic. (Downloading nested collections is not yet possible.)",
  "landing_page_label_news_date_16": "2025-10-16",
  "landing_page_label_news_title_16": "Braille-Übersetzung mit aktualisierten Standards",
  "landing_page_label_news_description_16": "For more than a dozen languages, we updated the default settings for the braille translation to deliver the best possible outcome for you. If you wish, you can change a different braille translation table when downloading the graphic for printing.",
  "label_today": "today",
  "label_yesterday": "yesterday",
  "button_older_news": "Older entries",
  "button_newer_news": "Newer entries",
  "button_close": "Close",
  "heading_voice_test": "Voices",
  "label_voice_test_text": "Text",
  "label_voice_test_language": "Language",
  "label_voice_test_voice": "Voice",
  "button_voice_test_insert_default_text": "Insert language-specific default text",
  "error_updater": "Error while performing updates to the graphic: {{log}}",
  "button_select_all": "Select all",
  "button_select_none": "Select none",
  "tooltip_account_privileged": "Share staff member",
  "label_attachment_basename": "Name",
  "label_attachment_size": "Size",
  "label_attachment_lastmod": "Last modification",
  "heading_attachment_existing": "Existing attachments",
  "heading_attachment_new": "Upload new attachment",
  "label_no_attachments": "No attachments",
  "button_download_file": "Download",
  "button_rename_file": "Rename",
  "confirm_overwrite_file_header": "Overwrite file",
  "confirm_overwrite_file_message": "There already is a file named '{{filename}}'. Do you want to overwrite it?",
  "confirm_overwrite_file_accept": "Overwrite",
  "message_attachment_already_exists": "Attachment with this name already exists.",
  "confirm_delete_attachment_message": "Do you really want to delete the attachment '{{filename}}'? This cannot be undone.",
  "button_preview_3d_model": "3d preview",
  "title_preview_3d_model": "3d preview",
  "button_replace_file": "Replace file",
  "message_graphic_has_models": "This graphic is designed to be used with one or more 3d models. You can download the models from the 'Attachments' tab and use them for 3d-printing.",
  "header_supported_attachments": "Supported types of attachments",
  "header_supported_attachments_stl": "*.stl: 3d models to be used with the graphic. The models can be manufactured using a 3d printer, and then be placed onto the graphic at the marked position.",
  "label_attachment_in_progress": "Attachments is being processed...",
  "error_file_validation": "While validating the file, errors were encountered: {{details}}",
  "button_apply_tip_table": "Apply current assignment table again",
  "button_upload_tip_table": "Choose assignment table for upload and apply",
  "heading_share_migration": "Short interuption of service",
  "message_share_migration": "We are currently migrating Share to a new, more powerful server. This process should take less than an hour. Please try again later.",
  "header_share_migration_cant_wait": "You can't wait that long?",
  "message_share_migration_cant_wait": "Temporarily, you can use the following address to use our new server by now:",
  "message_use_regular_domain": "You are using Share via the temporary address 'share2.problind.org'. After our server migration, please use the regular address again: ",
  "and": "and",
  "none": "(nothing)",
  "error_crypt_missing_conf": "The configuration for this feature is incomplete or wrong.",
  "error_crypt_not_found": "The requested ID was not found.",
  "error_crypt_used": "The requested ID was already used.",
  "toast_batch_download_soon_info_header": "Batch-Download in preparation...",
  "toast_batch_download_soon_info_message": "It might take a while until the download begins. Please be patient!",
  "button_rewrite_informal": "Sie -> Du",
  "confirm_rewrite_informal_header": "Rewrite from formal to informal address",
  "toast_rewrite_informal_success_message": "Successfully rewritten {{count}} texts to informal address. Graphic will be reloaded now...",
  "toast_rewrite_informal_nothing_to_do_info_message": "Did not contain any texts that needed changing.",
  "toast_long_process_info_header": "The process has been started",
  "toast_long_process_info_message": "Please wait, until the process is finished. This might take a while.",
  "label_ascii_math_valid": "All {{asciiMathCount}} AsciiMath text contain only valid characters.",
  "label_invalid_ascii_math_character": "Graphic contains {{invalidCharsCount}} distinct invalid characters in {{invalidAsciiMathCount}} ({{distinctInvalidAsciiMathCount}} disctinct) AsciiMath texts: {{charList}} (from a total of {{asciiMathCount}} AsciiMath texts)",
  "label_auto_translate_math_text_unavailable": "We are currently working on some improvements for the automatic translations of maths graphics. Those should be available around the end of September. Until then, you can translate math graphics manually.",
  "label_clone_magic_unavailable": "Graphics that use Magic Braille Numbers can't be cloned until we have finished the tools for editing those graphics. Thank you for your patience!",
  "label_tip_announcement_landing": "NEW: 1.250 audio-tactile maths graphics from grade 1 until the A-level!",
  "link_tip_announcement_landing": "To the graphics",
  "label_chosen_none": "Not chosen",
  "tooltip_mathtitle_generated": "Title is auto-generated from formula",
  "tooltip_mathtitle_changed": "Title was auto-generated from formula, but has been changed manually",
  "tooltip_mathtitle_empty": "When the graphic is saved, a title will be generated automatically from the formula",
  "button_mathtitle_reset": "Reset to auto-generated",
  "toast_resetmathtitle_info_header": "Titel has been reset",
  "toast_resetmathtitle_info_message": "The changed title has been deleted, so that a new title will be generated from the formula when the graphic is saved.",
  "label_magic_input_expected_value": "Magic Braille Numbers - expected result:",
  "math_format_something": "(present, but unidentified)",
  "math_format_ascii_math": "AsciiMath",
  "math_format_math_ml": "MathML",
  "math_format_latex": "LaTeX",
  "math_format_polish_notation": "Polish Braille syntax"
};

export { en };